<template>

  <panel-navigation>

    <div v-if="show_google_ads_popup" @click.self="show_google_ads_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
           Google Ads Connection

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_google_ads_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6">

          <!-- <div class="text-center -mb-4" style="position: relative;">
            <a href="https://ads.google.com/" class="text-xs" target="lsa-google-ads-link">Sign Up for Google Ads</a>
          </div> -->

          <div style="clear: both;"></div>

          <div v-if="!me.lsa_command_enabled">
            <product-access-required product="lsa_command" />
          </div>
          <div v-else>
            <div v-if="me.integrations.google_ads.status == 1" style="width: 100%;">
              <div v-if="$store.state.auth.owner || $store.state.auth.admin" :class="'w-full mb-3'" style="position: relative;">
                <p class="mb-1 text-xs mb-2"><strong>Your Google Account</strong></p>
                
                <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 -mt-2 mb-2 px-4" @click="connectGoogleAdsAccount">
                      CONNECT LSA ACCOUNT
                  </button>

                  <br clear="all" /><br clear="all" />

                <div v-if="!me.integrations.google_ads.settings.selected_client_id" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
                  <div>You do not have your LSA account connected! Contact your account manager to setup your LSA account.</div>
                </div>
              </div>
              <div v-else>
                <div :class="'w-full mb-3'">
                  <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 -mt-2 mb-2 px-4 float-right" @click="connectGoogleAdsAccount">
                      CONNECT ANOTHER ACCOUNT
                  </button>
                  
                  <p class="mb-1 text-xs mb-2"><strong>Connected Account</strong></p>
                  <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                  :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                  :value="me.integrations.google_ads.settings.oauth_account.name + ' (' + me.integrations.google_ads.settings.oauth_account.email + ')'"
                  readonly
                  />
                </div>

                <div :class="'w-full mb-3'" style="position: relative;">
                  <div style="float: right;"><a href="https://www.loom.com/share/e3cce502806a449a8cca77062ba09d7f?sid=47d833cc-61c4-40e1-a1ac-493b9df07a1fd" target="lsa-help-video" style="font-size: 12px;"><i class="mdi mdi-information-outline" style="font-size: 14px; margin-bottom: 10px;"></i> Setup Instructions</a></div>
                  
                  <p class="mb-1 text-xs mb-2"><strong>Select Google Ads MCC</strong></p>
                  
                  <v-select
                    v-model="me.integrations.google_ads.settings.selected_manager_id"
                    outlined dense
                    hide-details
                    :item-text="item => item.name"
                    :item-value="item => item.id"
                    :items="[
                      ...me.integrations.google_ads.settings.managers.filter(m => m.clients.length > 0),
                      { id: 0, name: 'No MCC' }
                    ]"
                    class="-mt-2"
                    @change="refreshLsaAccountsList()"
                  ></v-select>
                </div>

                <div :class="'w-full mb-3'" style="position: relative;">
                  <p class="mb-1 text-xs mb-2"><strong>Select LSA Account</strong></p>
                  
                  <v-select
                    v-model="me.integrations.google_ads.settings.selected_client_id"
                    outlined dense
                    hide-details
                    :item-text="item => item.name"
                    :item-value="item => item.id"
                    :items="lsa_accounts"
                    class="-mt-2"
                  ></v-select>
                </div>
              </div>

              <!-- <div v-if="me.integrations.google_ads.settings.managers.length == 0" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
                <div>There are no Google Ads MCC accounts found. Please connect a different account.</div>
              </div> -->
            </div>
            <div v-else class="text-center p-10">
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: inline-block;">
              <rect opacity="0.1" width="70" height="70" rx="5" fill="#44468F"/>
              <rect x="16" y="18" width="37.1733" height="34" fill="url(#pattern0)"/>
              <defs>
              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_1047_27365" transform="scale(0.00609756 0.00666667)"/>
              </pattern>
              <image id="image0_1047_27365" width="164" height="150" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACWCAYAAABQByPnAAAYhmlDQ1BJQ0MgUHJvZmlsZQAAWIWVeQdYU03z755UAgm99957L1JCr9I7CiG00KWDIAqIAirYEAFFmkgXLCAiAlJEEaQICBZAUVFULChK+x+Kfu///e5z73M3z57zy+zs7M7s7sxOAgBXFyk8PBhBD0BIaFSEnYk+v4urGz/2LYAAAv5AAEUiR4YTbWwsAVz+vP93+TEG88FlRGZT1n+3/18Lo49vJBkAyAPG3j6R5BAYtwOASiGHR0QBgDGE6UKxUeGbOADGzBHwBGGcuIn9t3HOJvbexmVbPA52BjBuBoAKTyJF+ANA2wXT+WPI/rAc2tdwG2OoDyUUZl2GsQ45gOQDAJc6zCMdEhK2ieEKxGH+cBgfg7G69z9k+v8v+d5/5ZNI/n/xtl5bhcqQEhkeTIr//zTN/7uEBEf/GUMUrviACFO7Tf1hG04EhVlsYjyMF0K9d1tv2hrGyxSfbbsDgKAOiDZ13OZHcJMjDWD7AVYYy/uQDC1gzA1j49Dg3ZY7dG8/irEZjOHdgoijRJk57PQ96htpZL8jszAizM76D/aLMCDu9K0jRWyNu8nfFR3kSNyRPxHga/ZH/veEAAdnGFMDgKSOoTjthjEtjJkjg+wttnmQggkBBrv/8ERE223OXxjG6r6hJvrb8pEefhHGdjv84SGRf/RFpgdQzHbv4LyoAAfTbfsgq8ikrfmzw/imbyjR8Y8c30gXyz+6+PgaGm3rjhzwDXXc0Rf5IjxK326n72J4sM0OP4rKN9hkky4IY87IGPudvqhdUfDm3JaPsgyPsnHYnifKK5BkbrM9H1QMsAQGwBDwg2i4eoMwEAgoAwtNC/C37RZjQAIRwB/4Apkdyp8ezlstofDTHiSAjzDyBZF/++lvtfqCGJi+9pe6/ZQBflutMVs9gsAbGIcACxAMf4/e6hX6dzQn8BqmUP5rdDI812C4brb9N40IUyx3KNF/5PLT/eHEGGEMMaYYY4wEihOlg9JCWcJPPbgqotRRGn9m+x9+9Bv0EHoW/QQ9jX7qSUmJ+NdcrMA0LN94R2Pvf2qMEoVlqqD0UdqwdFgyihXFCWRQyvA4RJQuPLIKTDXYmfem7vz/Bz3/avAPm+/w4eRxCBwbTg8n/u+etJK0Kn+lbFr0n/bZnqv3X6sa/G359/gG/7CzD/y2+Dcn8ijyGrIX2YHsQ7YimwA/8i6yGdmPvLOJ/+6h11t76M9odlvzCYLlUP5rPNLOmJuWjJSvlp+XX91pA1G+cVGbB8wgLDw+guIfEMVPhKOAL79ZKFlWml9RXlEJgM2Ysu2mvtltxQqIdfA/NMoYAKoNmz7rPzR/+Fy0zAKAs/wPTaQGdgewz76PI0dHxGzTUJsPNOwN6OATxQF4gRAQhzVSBKpAC+gBI2AOrIEDcAV7YTsHwPs5AsSCRHAIpIMskAPOgnxQBErBFVALGkETaAUdoAc8BI/BEzAF75858AEsgh9gBYIgLESAmCAOiA8SgaQgRUgd0oGMIEvIDnKFvCB/KBSKhhKhVCgLOgXlQ8VQJdQA3YI6oD5oCHoKzUDz0FfoNwKJwCOYETwIUYQcQh1BRFggHBB7EP6IfYgERBriBCIPUYKoQdxEdCAeIp4gphEfEEtIgKRBsiIFkDJIdaQB0hrphvRDRiAPIDORucgSZB2yBV7pEeQ0cgH5C4VBMaH4UTLwHjZFOaLIqH2oA6hjqHzUFdRNVBdqBDWDWkStowlobrQUWhNthnZB+6Nj0enoXPRl9A10N3ya5tA/MBgMK0YMowafRldMIGY/5hjmAqYe044ZwrzCLGGxWA6sFFYba40lYaOw6djz2BrsXewwdg67TEVDxUelSGVM5UYVSpVClUtVRdVGNUz1lmoFR48TwWnirHE+uHhcNq4M14IbxM3hVqgZqMWotakdqAOpD1HnUddRd1M/o/5GQ0MjSKNBY0tDoTlIk0dzleY+zQzNLzwjXhJvgPfAR+NP4Cvw7fin+G8EAkGUoEdwI0QRThAqCfcILwjLtEy0srRmtD60ybQFtDdph2k/0eHoROiIdHvpEuhy6a7RDdIt0OPoRekN6En0B+gL6G/Rj9MvMTAxKDBYM4QwHGOoYuhjeMeIZRRlNGL0YUxjLGW8x/iKCckkxGTARGZKZSpj6maaY8YwizGbMQcyZzHXMg8wL7IwsiizOLHEsRSw3GGZZkWyirKasQazZrM2so6x/mbjYSOy+bJlsNWxDbP9ZOdi12P3Zc9kr2d/wv6bg5/DiCOI4yRHE8dzThSnJKctZyznRc5uzgUuZi4tLjJXJlcj1yQ3gluS2457P3cpdz/3Eg8vjwlPOM95nns8C7ysvHq8gbxneNt45/mY+HT4KHxn+O7yvedn4SfyB/Pn8XfxLwpwC5gKRAsUCwwIrAiKCToKpgjWCz4XohZSF/ITOiPUKbQozCdsJZwoXC08KYITURcJEDkn0ivyU1RM1Fn0iGiT6DsxdjEzsQSxarFn4gRxXfF94iXioxIYCXWJIIkLEo8lEZIqkgGSBZKDUggpVSmK1AWpIWm0tIZ0qHSJ9LgMXoYoEyNTLTMjyyprKZsi2yT7SU5Yzk3upFyv3Lq8inywfJn8lAKjgrlCikKLwldFSUWyYoHiqBJByVgpWalZ6YuylLKv8kXlCRUmFSuVIyqdKmuqaqoRqnWq82rCal5qhWrj6szqNurH1O9roDX0NZI1WjV+aapqRmk2an7WktEK0qrSerdLbJfvrrJdr7QFtUnaxdrTOvw6XjqXdKZ1BXRJuiW6s3pCej56l/XeEiWIgcQa4id9ef0I/Rv6Pw00DZIM2g2RhiaGmYYDRoxGjkb5Ri+MBY39jauNF01UTPabtJuiTS1MT5qOm/GYkc0qzRbN1cyTzLss8Bb2FvkWs5aSlhGWLVYIK3Or01bPdovsDt3dZA2szaxPWz+3EbPZZ3PbFmNrY1tg+8ZOwS7Rrteeyd7Tvsr+h4O+Q7bDlKO4Y7RjpxOdk4dTpdNPZ0PnU87TLnIuSS4PXTldKa7Nblg3J7fLbkvuRu5n3ec8VDzSPcb2iO2J29O3l3Nv8N47nnSeJM9rXmgvZ68qr1WSNamEtORt5l3ovUg2IJ8jf/DR8znjM++r7XvK962ftt8pv3f+2v6n/ecDdANyAxYoBpR8ypdA08CiwJ9B1kEVQRvBzsH1IVQhXiG3QhlDg0K7wnjD4sKGwqXC08On92nuO7tvMcIi4nIkFLknsjmKGb6890eLRx+OnonRiSmIWY51ir0WxxAXGtcfLxmfEf82wTihfD9qP3l/Z6JA4qHEmSRiUvEB6ID3gc5koeS05LmDJgevHKI+FHToUYp8yqmU76nOqS1pPGkH014dNjlcnU6bHpE+fkTrSNFR1FHK0YEMpYzzGeuZPpkPsuSzcrNWj5GPPTiucDzv+MYJvxMD2arZF3MwOaE5Yyd1T145xXAq4dSr01anb57hP5N55vtZz7N9ucq5Reeoz0Wfm86zzGs+L3w+5/xqfkD+kwL9gvpC7sKMwp8XfC4MX9S7WFfEU5RV9PsS5dJEsUnxzRLRktxSTGlM6Zsyp7LecvXyysucl7Mur1WEVkxfsbvSValWWVnFXZVdjaiOrp6v8ah5XGtY21wnU1dcz1qfdRVcjb76vsGrYazRorHzmvq1uusi1wtvMN3IvAndjL+52BTQNN3s2jx0y/xWZ4tWy43bsrcrWgVaC+6w3Mluo25La9u4m3B3qT28faHDv+NVp2fn1D2Xe6Ndtl0D3Rbd93uMe+71Envv3te+39qn2XfrgfqDpoeqD2/2q/TfeKTy6MaA6sDNQbXB5scaj1uGdg21DesOd4wYjvSMmo0+fLL7ydCY49jEuMf49ITPxLunwU+/TMZMrkwdfIZ+lvmc/nnuC+4XJS8lXtZPq07fmTGc6Z+1n516RX714XXk69W5tDeEN7lv+d5WvlN81zpvPP/4vfv7uQ/hH1YW0j8yfCz8JP7p+me9z/2LLotzXyK+bHw99o3jW8V35e+dSzZLL36E/Fj5mbnMsXzll/qv3t/Ov9+uxK5iV/PWJNZa1i3Wn22EbGyEkyJIW1cBJFwRfn4AfK0AgOAKANNjOE1w3875dgoSvnwg4LcTJAt9QHQhI1EiqPfoYownVgA7RVWCC6RWpF6lGcQXEaJod9NJ0GPoZxm6GS8zZTCHsTixGrE5s4dwpHNe4mrhHuZZ4MPxCwsQBb2EkoQLRG6JTor9luCS1JHylk6VqZQdlPumwK6oq0RWzlJpUB1S+6RB0JTUMt7lrX1AJ1/3ut4A8a3+uiG7kayxoYmzaZBZovkJi4uWdVZ3dvdbT9q8sf1uDzngHdmcuJ35XIRcxdyk3RU9NPcY7LXwdPQik8K8D5CP+xT5Nvh1+08GLAZSBfEHa4TYh4aFZYaX7+uIeBG5Es0eoxLrELcvPiehfv9g4ucD9MlKBx0PxaUUpnakvUnHH1E66paRklmZNXJs9YRotnVO/MmyU49Ofz5Ll6twzjEv7nxhfkfB2wuEiypFHpdSi6tKhkp/lnNfJlb4XjlSeaWqt/p1zUYde738VZMGj8aIaxnXL964erO16V5zz617Lbdv17bm3znURr6r187W/r7jVueheyZduK4H3ek9xJ6V3uv3g/oE+yYfnHxo2Y/vH3qUO+A2yDs4+7hsyG9YfHh+pGo08Inkkw9j1eNBE9ITH5/WT+6bUp5aftb6/NAL45eEl6PT+TN7ZwVn51/deH1kzvON9luhd/Tz6PeID9QLXB/VPrl/PrLY8uX7N+XvcUttP7HLtr8Kf79ZlV2LXm/Z2NhafyHoKsIVyYBsRLmjqdG1GBf4VlNPRcKx4x5Sp9Ho49H4e4TDtGZ0tHQT9CUMwYxqTFim58z9LD2s7Wx32Js5rnFe5arhruAp4y3lK+UvESgWLBEqE64QqRStFWsQvy7RItkh1S39QGZYdkLuufwLheeKz5QmlcdVnqiOqA2qP9Do1uzQur3runatTpluvl42MVU/1iDQcI/RbmM9EwVTfjN6c2C+aPHMstuqZvdp6/023rZmdvL2HA6Qw7zjsNNt53KXbNcEN193a49de8T2MnlCnp+8pkh93k3kcp/Tvml+h/xTAlIpqYEpQanBKSGpoalhKeEp+1IiUiJTog5FH4w5GJsclxx/ICFpf2JiYtL+AwnJ8Qfj4N2RnVqe1np4NP3DUWQGZ6Zilukxr+OxJ45ll+W0nHx86s3p1bMMuWLntPNsz/vlJxacLCy70HJxsOjVpZ8l+FKBMtVy88t7KyLgHVJQVVfdUTNa+7bu91V8A2+j3DXidbsb5JuRTWnNZ26Vwx6sq3Xkzqu293cft9d2ZHb63zPs4u9a7Z7oudZ74j6lz+ABz4MfDwf7Kx4lDzgNyjxGPZ4cahhOH/EYVXiCfjI11jCeOUF5ajGpOMX3jOk53QumlwLTWjNes6dfjc6Jvzn2DsxnfBBcePQpY9H2q/h3mqXln59/vV/5uPZta/2lQBdkAU0g3BEfkUHIZVQKmh1dglHBPIRvtGtUBTgd3DT1ERpFmpf4LMIuwgLtBTo7ehr6boYTjJ5MCswo5lGWctY4Nit2PvYljgecxVxx3NY84rwQ7yTfNf5sgUBBYyEhoXX4HtUsmisWJW4jIS6xKjkkVS4dL2MlKyD7Ra5D/qSCl6Ks4i+lTtg/2Kuyq06pFamTNAQ1ZjSLtPbu4to1rn1ax1qXoDusl08k60vrfzO4bZhmZGnMbDxlUgr7C0WzX+btFkcsra1Y4ftEiTXFRtbmu22LXbK9kQO1w4DjSScHZzbnSZeLrt5u4m6f3G96HNxjvpd172v4HpBGcvaWJiPIkz7XfXP8QvwtAqQoNJSPgY+DrgfnhsSGuoRphnOFr+17GdERWRqVHk2JsYpViGONW4mfTXiwvzGxIOnwgfBkj4Nmh1RThFIZ06C0L4ffpM8dmT/6KeNr5o+s38fWTyCyMTm4k4RT9KeZz7Cd5czlPSeQJ3xeLF+yQKZQ4YLyRbUirUs6xcQSi1Jy2aHyosttFZNXlqtYq5VrbGtD6jLrK652NUw3rl5nu6F007opsPnwreKW1ttjrV/a8HdF2/U69nTuv3euq667p+d57/c+ugdyDx37Dz9qG8Q89hzqHbEYnR0rnIidTHh2+SVupub1ubdDH6I/Z3/X+1Wzuf7bv/1tFowqAOW6sEOA44Z9CQClrXCeqQ7Hj3IAbAgAOGgAhEMCgF40A8j1/N/4AcGJJxWghzNOEaC09XtIEEiBc8kbYAh8huggBcgBSoBzwAfQEoILoY8IRJxGtCHeI9mRJshYZCXyGYoeZYxKgnOyRTgPC4BzrzmMCCYAU435jFXBJmF7qOipPKgqqX7iTHGFuK/UZtQl1Gs0bjTNeHZ8Av4FwZBQQ8tKe4j2M50n3TC9Mf0dBlWGBkZZxjomOaZrzBrMnSwWLBOs/qzLbDnskuzdHN6cELxL9bnmuDN55HnGeJP5xPlG+A8ISAk8FTwqpCH0XviCiK0oVrRNLEZcXnxBolLSX0pM6r10rUykrIYcQq5fPk/BR1FJCak0qnxZJUHVRk1UbV19XKNR84RW0C5zbUkdvM4n3RG9ZuIl/QyDKEMvIytjAxMdUw0zZXMFC3lLeSuF3YrWqjZatkQ7M3t7B0/HEKck5xyXctdWt3H3pT2sezU9yV4nSG3eX33Efcl+l/xfUngDyUG1ISDUPezuPpmI8ijJ6NuxrvGYhHuJOQeCD3qkuKf5p6cdrcl8fpw92+lkwenhs8t5/PnWhekXu4qpSm3LSyp+VtnXNNazNCRee3XTuvn2bYk759upOxO7lnoP9G307xsYHhIaIT3JHq95emvq+vOSlwdnHF7xvn75Jv+d9fzGh5qPLp9Ri3VfXb6jlhp+kn4x/+5bTV0nbvkPCKABDWAG/EAOEOHVDwFHQCnoALMQGpKC7KBEOPsfR2AQCnBun4VoQSwg+ZAOyCxkF3IdpYmKRTWhltFa6GR0N4aAccKUwKuujT2OnaZSpsqgmsFp4c7jflG7U7fTiNFk0/zGB+AnCOaENlpV2no6abpqehn6RgZNhi5GW8YZpkhmKuZiFi14tePgDPM+ewyHCMcE53EuI6517ts8CbxavOt8XfzHBJwEhQS/CN0TzhUJEjUQ4xH7Lf5U4rbkRalYaWsZSVms7Du5Pvk6hTOKSUoUZWcVE1UNNVl1UQ1+TW4tzl1c2nw6IroyempEQ30HAz/DBKNs4xyTM6Z5ZhfNKywaLNus+nc/t/5ii7bjtldzsHUMd8pxbnQZc11zF/Ow3ZO8t95zhsTibUE+7HPXd8VfKyCRcjcIFWwZcjZ0Jlx+36GIkShxOCJNxanF5yYsJ3ok3UuWPpiXgkmNTfuQTjryNMMhc+iYzfHRbNec6VOUM9q5onlM+ciCXxe+Fn0u/lr66zLqCkuVZI1hnc/VI41Xr79sYrhlejvtTnc7TadD18Wel32sD40eBQwmDaWNJD8JGDd4Spjsexb9gvllyYzwbMFr7Jzfm7Z3hHn792c/DHxEfVL97L147MvVr6Pfvi0x/pD5abJM+rX/96mVytW7a2Pr77fWHwGffkYgAJ99c+ADn/wS0AMWIBaICIVDJdAYAo/QRUQjahHvkKJIX+QV5AJKCZWIuo9mRfuhb2FoMb6Yu1gubAJ859ShKsMRcPtxn6jJ1M9oXGjG8e74WUIIYZU2h06CroeewsDAcIcxjEmUaYa5hMWfVZF1ja2TPZPDkVOEc5lrgLuS5wgvhc+aX11AVJBNCC+MEUGKosWoxZklBCSVpCykKTIZsrVyo/KriqJKtsoHVKpVn6pTaahp+mqd3dWtvaQrqudCzNJvN/hhJG0cYFJl+tFcySLJsm83u3WgTZsds32IQ6+TsHOKy4ybgXv5HtzeMM8xko53pQ+rb6rftwBfSm+QQHBSyFTYrvDiCGxkWNRUjFlsS7xMQmkiV1JuMtPB0yksqfmHBdNrjqpl9GQ5HXt/4mAOx8nG08Qzt3NVzjWel8+/Vqh6obXI4NKjErfS+fKECsKV0iqt6rHayHrGq9cana+t37jcZNO81lLbureN8W5fR8q9XV3fe2ruBz9Q7YceDQxeGKKMKI0ujdVN7JlETRU+F31RNs02Ezvb/5p9zuZN6tvyd3fnH74f/HB/4c7H4k/pn10WxRe/f2n4GvpN5Nvj7/uXhJfu/HD6sfjz0DJu+eQvzl8Fvxl/Z65AK/Erc6tWqzfWeNYOr82vE9fz179tWG1c3lz/SD8lxa3wAeH1AUC/2Nj4JgoA9hQAayc3NlZKNjbWSuFk4xkA7cHb/ydtxRp6AAp7N1FP11X8v//L2f6v6R95zL/fYCsSbY3qmrftheCoBP4HawXuW+27sEAAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAAKSgAwAEAAAAAQAAAJYAAAAA2U1RWgAAF9VJREFUeAHtXQt4FUWWruru+8iLhCAGYZAICRH4BFQUIYA4gM7uzH4y4mNwcX3Nig+GQUxAUDEzLggBBB+DOvuQcb8ZRz91GJ3d73NAV4cQRgWJIJgEcIKMPBIIeSf33u6uPXXJJTfJzX307UdVdxry3b7dVafOOfXfU1Wnqk5h1H/FrYHppZWFBOHpCKNpiJBL4D4TIZKFMR6ECOqA+waCcQMQPAP3BxHGu5FCtu9afvmJuAtxeELscPljij+ttPIHAMAlCOGbYibuKwEhhwG8uwGsHyse/M6ni/Ob+krq9Of9gIyAgHElB91ZaeJdGOGl8HpshCSaHxGCTgMwV5QX5W8FC0o0E7Jpxn5AhlXstGePDURi+yNgzRZhjHLCXhlwS/YiLC0sK8rbawBxbkn2A7Kz6gpLq6YDCN+Dr1lm1SaYRwL/fkOwuLy8OK/WrHJZLqcfkFA70E/8OXxsgCZUsqKyAJX1SEU3weBnjxXls1SmowEZ7CumSq+DZbzD8kqBUbqKyU/Kiy//o+W8WMiAYwE5fc3hwaqk/C+4bCZZqP/eRRO0qGxZwa96v3DGE8EZYnaX8upXiYtI6p+YAyNlE6OXCtdXlnbn2DnfHAlIb1PVi1Dx17JazeBuKoZ+7ZOs8mckX45rsgs3VN0N3r+tRipVD9rgr1TBgk8tKx79qR70eKHhKEBOWVd1rSCQMrBALk4q6DhRyTgYfTdzwm/SbDqmyZ6+qeYSEaM/cQRGWrnDoWvxWtK1zBEBxwCSBHwboXIHc1Q3QVah2Z43dX31vbzxrZVfRzTZUzd8M0IggRqtSrI6HyGkTZXw6N1LC76zmhejy3eEhcRqoNhoRRpJH6xkqqCgtUaWwQpt21tIumCCiO2noFLdrChdKx+KIFy1+7H8fVrz85DP9hZSFduX2gGMFEyCom7hAVTJ8GhrCznlueMpotz6HSyaGJiMkljKqxJ8a/my0e+wxJOevNjaQi4fVrzeTmCkFY+xupFOfeoJApZo2RaQ/o/Q5HbVO5MlZevBC/hRR6Q0VC/WgxaLNGwLSKK6Xt3ZMKuARaUnyxMR0Krg6vZkCTGY35aA9G8X78OEXPF16wRLFtwaXc/Q8R9ApI5fGl2OFfRtB0jyfygdFLm2PpDdFCAeK3RqSpkAyoemPHckz5TCTCzEdoD0K9Iq6PkPrlcGB0zUoxVFiaKsbLKiYCPLtBUgySdoOEYE9lAjdNo/1NYurSAoMPrR9NLD1xsJELNp2wqQfr/4IjhGgi6Rs4GL7dteh6GEIAVkts9lG0AGdiDYxopvDlWNC/vE0L2tPzG+AlaX32cXGW0BSFhdLahIeiW8Ury4XQ7/bu97vPbqkhOpdpDRFoAM7BAegQ7j2PAKSRHb7T6o6RIX1nl6UptWdD3g9457QIKbJwtG1b/oWQXZrjruZespU7TvAsbFhesqh0ZLw8M77istoIirYSDTa/HEpd6aFB4qQEcePUjA63SkZwkprgFJtqMxEBtnYSTNeYV2b5Z0NtIr2z6DbssCsJJsBT5IUNtcAzKAYSCDcZ+j6VzvkQTVwX9yLOCXeJaCW0DKO8S5oPgZ0ZQ/IWOPE+MvTp66vnJBNL2w/I5LQMJARlIIej6WYudkvd8aK40d30OllvLqBuISkLIsFIET/NJYYBrqPZ6e47b9Rr0IasCXeFObn4jwgvlH3AESrONFEOH2qXg1O2fg+/5409opHYQYfGza2qMxf7SsycwdIMHNQwOLxj0rcevFr3cIyEGTNl0I8xBR5m41EFeAhG0JE8DneHeXzmPfDZAaB9w0aJszrSRCt0zdUB114Bdbg+am4AqQSJFe1aKeB4dtbHeolUQCIS+jt0ifrjEt+jQyDzeA9G0X74TYPJO1KCNDbMr8h+x327TktUGesdO+rY44ecCibFwsYiXlKMXfKh6FkfUlWpXoI57muV/uyvARp80ogsYIOYeUlFFlK0ac06o/s/JxYSH9rdLKZMBIlenBvoyfDtsER7458IJACbxsCmPeQtJtCQG/eBhG1kmvAId1k/L8gzuk2oBmQ8szmhWMhfE7i/IPsSwE8xbSHxAhrmPyYKSVAL45aWVusVMPwhRVor7MMhgpb0wDMrgtAeHb9FTi+PR9Qyekf+5UN9AMCGtN1wAwezENyJ7bEvTS4qrcxxoFpOhFjis6AibPsxwbiFlA+neID0AHt9u2BL1qfqDr7OBbc15v1IseT3ToGoCUpip6yi2TF5ODGpivTocpwm8jrQTXS4sBVWqd99Vf0lqUTL1IckOHhogWZDF358r8OtaYZtJCAlh+aSQYaSW4BDntZ99bfZq1CjGDH7CSqaqkbjCjrETLYM5Ckg/RqIAqVsGQ2IzpLuXer98Tj3WMSlRvtkjPYoho5iykXxVfMAmMFFTi07lLHWklqfAshohmCpCBHdJsaE7+kSrLrCs35UjOjMwPfGaVx1I54Je9btr66juZ4okVZmj0CRhZVwEgTQ8x16KkN8w7sDMrQLg/qCHh6oQBzonTXnHkkcX5TPwombGQEH1isRVgpDWYLrZkLch5pSHh2rRBBtD50CE+dQUrojAxqAE3T1anmyfDKsUoRPDd8dVHnnqZu9Pn9FCZDw75HAmHfFo+rcqEhQzI4hpw81gGRlqjIlY9j136dK0etcshDQ9YSibcQJYDMhh9AqEHWKjEKZmfXDwm9UtnziliNL9w3eHrrK4HywEZK/qE2QqCeW7mF7EaphPB+pPCLAWkvF28GZTL1CakHM/Ji3446G1HBhiAAcWVhRuqEtpEp/ePw7JBDQxkJL8c3JbA3N7hDtXb8uP9ZenO3O6A6trbMnL3lgy1ZA+SZRYSok88Ch1p5sBIf/FeoSN94dCNzgqdFjJ1EPw0Ja1pZeir2Z+WWEgafQLcPN9YPbKOpmyHb3fwqdhVUF408lg0HRnxzhILCWB8lmUwUkV3bnc4ZYTSOaDpEVT/eiv4NB2Q56NPoPutEDbRMmG7w5DxaZ87Mg4L/CJvs8INZDogz0efAPvDybXqsqIGp253gLMttsCeblPrylRA+j4Ub9MafcIq/Ga7zlw0b/DrzVaVb2W5gETqBrrPTB5MQz85iNz+E+JhVkfW0ZQeIK7WeQc+ceR2B4jhXhfwCnmfLs5viqYjvd6ZZiHlU0Ixj2CkinbhQNqiYWvr9VI6V3TADeTqUEwLfmqKhQy6eWTxGHSU447ryGClEdjugJ243YEgEiDYnW+GG8gUCwmreWj0CZ7BSH8f+IncYkdaSQwHmgpqYLMZRsJwQAbdPBj/ixnCGF1GXkpV9ozMP6tGl8MkfYzmmnEUsuGA1BpklMlKAaaWXlrS6sKOjMSCCDbeDWToVlMaZBQGMotZBZcWvjyCz6MQ0fdly7WSlvyc5xk8fHf9qeN/fnGPUXIYNqjpdPPUACBtF/sOAOm/46sP3Y7c7gDBTwNeMdcoN5BhTbb/RPJBRo36FSZLV8SKe9Gw1Y5cMwmD04FSh1qSrA77ym+IhQQ3zxAYWdcA80kHGe2LcRaeP1z1BqpsG88CK6byQN1AqiiN3b00T/fDJA2xkLCaZ5PdwUgRsGLECkdaSeoGEhXFEDeQ7oD0b0ewUQj/xNSfrEWFDffWpM0Z9J5FpVte7A8h+OksvbnQHZAIScyHDdZTiQ8PLW2TcEBPktzQEgT0it5n4OgKSP+H4j2wmmciNxrVgdFM6Vzq/Jxfm7LwQAd2dSUBA5C8wmPVD+lJVLdBDdmDUv0NsGkL4SF6MsgDLZXg5lkVBwIgezYP/OrMY4M/oOZ9tnKMLnuQdLOQ/gbpSSeCkVYuxmQzwoJpK2J0BlSy5LJcLqEkWSKh/LpYSD3PkgkxxssnRA876U5TRk06QGRvU/Uh2ozxwruOfOp2Bo4uFhLOknGEmydiBWK0FE9F7XsX4gAm+NGIaez/UCSqskUPMZO2kPQsGYKkv+jBDIc0PnfPlq8N57uwtPIDmC69MfyZU+4hgtrNEEEtKT9Y0haSEOkFpyi8l5yq3CtIlipJj0A6ZwasEtALyZ6BkxQg/dvF+5zm5ukCJfm1+0ZU0fX9/B2dToMgA7o0Xz1ps/4dBrUjvE2HlyTDp2ZA0iODoeC1yRTOb17S7CLKsr74x4r36eCRwH0lsPVz8uT0NYc1R33VDEg4MngV+Ds0F8x3nZCn8BzU50lg58+lxk/xLaM27mFQMkB1qRCZRNulaVATdPMExKPggXNpK5bfXNAcV8JAZhyEOoi+leEtIk47Vr0fJB3Lr7TaOCdwZLwqCFfvfix/X6IUNFnIoJvHgWCkyhUw+llMMNKEt2MFE+Fheuu0C6wc1noGTsKA7DwyeJ7TlEzlBSf4e67Z8o54Zd+5LP8Tmife9HZKBz/a6wrXV96eqEwJA9KoI4MTZdz89CTgFpSliZZLBPdiuqA10Xy2SE/QprwXDie0SDuhjUrg5vlXUFTMPlEzcaGKwCB0UB7Y5CNiU42SJp9U00Rqyl1I9dC/a9x12I3VjCtdZ1Ce2IQyGF/CBTGXnsezEfSbE7vo5nqwFHQxa3FiOflPDRMEQ3N8yjJYVv5MvNLEPaiBbQnpsC3hm75G1nsCgxrfbx9xZm9gUEo9SRkaLwOhdMOElsbZ3pPSDZ7v0kYDQJm6CKlzScpIfANq0cLX5BcOD3B1qEfAZ+s4rwR0WdogPlB+vGfgxA1I33ZpPfQLinpWyNvtuce3tI3xdhCXbsoeIrSevTetOuWfPMfZiHZByAPuOcq/95Q9ke9gJe8Hx/F/JJLHLmkBlL/dtezyBfHIExcgyQ40MoCkbs3Vi23jTr3VlpuhIDEtnoK0pEnBgbpH0g8pt3iOWbnGcj+4eSZo4b9bHmjzCzdU7wWFX9ntuUO+gB9oyq7l+X+NJW5cgxo/EZ8LEaqSM3w/qr/x72+0jRpiJBhpee1gdTc0Txhy89k5p78IZCshHsz8xEhepEt5sGgSqc50AwX1F+cZODEtZPhqnpdax9X+rn3UxbpUkAYid6YcPb0o7WCOhqyassDo+B3PbOVWTZn7yFS4vupNUHrC7pA+yPH1mKC7y5YVvB6N6ZgWEpaWvURHzXPrZ9dZCUYqBJSfc1v99xspP2ZcbpK4mycWXwS76Bw4E0cBx+JV7/fwA3/26pITUccFUQHp3yEsrFYGjL/l3Kz6WjVVt0FLMoJ+p6Zn3nNuxjngKxkyMfPC9NcamK/+NmbCBBNQN5BKiCUnHCTIqu7JqRso1hk4fTbZpAxl7G/JrnmwYXpKAIl0ZQ9TlwfLvlezyjyGuIgIqXWp4Oa5CbUaITS1Et7UJhreOmH3mBH8mEwz6hk4fVrIt85d9m8PNMxwswhGqkAfkTwLz03zG9R8rzAKjJR3emwbnG2wnN478PIIxN/nUcgRLeTEN+bmihjvA79ZFusKGy60tLyZ/VG6XnxCU33IA6t59KIXjU5hadVuOucbLY1d38HCk5l0rr+nfBEtpITxazyAkQpzXE1Pf7Z5fENPwbR+F5D8oNa8ieZTRee6gfoKftoLkFe9ccs9MOU8M1HlWpn+fV9u1hf+7OjrE+NgkLp5XLPRzjiS6pKkc73gf+tCjD8iY6duqP5pT7a7AXLiH+Zmgf92U89EPHx/ovkaTfPMXbLBah6XYvo2Vtip93hwvreLEcfcCQStpvP84QJ3A6TUISzhpakOF4LeNxLPgJdbLtcMSoLwBnw9Ot6TrtHfzy86wKuNLodJ+vQMHFgNFM5bN0ASTH4e/pK3+993jBI1jbphNY87VX7GKnlPe4WN0F04ZlX5VpYLg8iHwtdMXgAk7Tvyah1DCqUuqo98l2jxHS6n0SdCdMz+PLI430ew2Gslldl8WFEeYC47p0O9K1T2BUBC3/Hp0EOeP7e0jpET4p+gClha9lpCeQxIXF6U/zbskejlBjGgKOZIguvrQt89CMhO65jLHKcaGGomnsyEphUFeaGGYgzJggXxYWjC4L/jrrFT11d+n0odBKSAyd12UsE77ZfVxycPedM9C30WX1rjU+0syj8Ei9SSWghsPJfGlCAgHNw42Nlk45nGFGMN1b/6B8dutgnxQeT2pMJ+GCKd4n0cTCRjezgMkbQHUTKZPhAmvTF3Zo833H+tU1NjrtkkGJfCHplTrAlLo14AIH/BGl9G8wML6q+kgaoEFQm5RhdmBf19sOuxrwtcLKfAzaM53EdfdPV67hsw+kUA5RG96PFABwY2Qmpj1bUQSB/l8sBwojx+FRgYzUleZKWbJ5YsNPgpOOrZ607EYjzJ9xCGdzLgkcxMkg6T2WsVb20fjH0O2xJ+28c7Zh6XF4/+H6ibD5hhyARGMCJXC7Aub4QJZZleRD3yRtgmALPGRL7fdGY0FqiIEt1gZsnmNo0sJ5kNfw9iJ+HcJKkwmf1vcnrvtZwEveqZgw4wyXAEpmjwU9ju8FKEV/Z8RNCATrePLeXrsRyNNLiQ8jhvkipecRWYdV3OgOFAdpdtAZmClR6+SPJEtCCjrFYWPZcaRtxPscqfznw12xaQBVJjR0hZ54OMqltC33n7LC8ueAV4PsQb3xr4rRfsOqHvRsqFEC+CwM9AJmIlwsoXRwQ/xaiejrJ1248SUZkWPRwo+js3pJPfu2ahcovY0K3Yzg1Rf9CNIIOEMEJHYV0FrmCQt6RZukI6OxCsfxvMV19Y2pQ0UYsJqNj1KMwy2Tf4KcF7oA+pfmyxng0p/ipXPezDJ6tZnK/WKjCNeoEI3qg1P+v5VCx8Jsje3of/sM54LP4uEtpqwVVyXBLV0lhpeXvf0ZbxDKyYrOON71j8gifhu/LivFqh4sfbGqAZ+DJWBp7eX+M6o4gCegSsYw/XD09SROaVRr1QEe62MSpySr6ewjpQmCrtXKAL/chtfLEfndtxrvpvpFnK+9FT8fu2fNnorWBR9vErQW/OoUULLkwO+iFlpG7tnYTfJxdJ6Sv45T5Ozm0U/BT8xAdhO/AeKnkQkBXzt9VAs/3HOFXBdDL4pf1m9g/272SaSR2Yo+GRoc5+pwMpy0lgoeuw0q6ZGky2Ws5ZkgxAM9aoIFKSJBl+sqvBo0YirGriRwTg1NfekrE1xPEFQO69Y9s23gc30DHeTK19SDi7f3ZGvXiGZzmhuV5DB2ohGS4Akj7AhCwJveDtEwQ7JnvVzbzxnSy/Umv+OqCxP1k6FuU/5GobvSa87G6A3DN/28dgJZ8PT8DLPRzOeg91YfHCr158flyCZQWjO6Dv7NeLphl0oHsFcbbwP1P+w8vrBkj6QvGQEtoXC0/E+j39EdEfE+t8GsXf7qKCSmjfHjeKvjF08fPgvqroSbsXIKmVUQR1Zs+ErH6n/V76I2KVP7P42rWsYBN0W/jwLhD0tSqmrIykm16ApIkqbt9WoRJ0b6QMLD0Ljqo9ZKYTm+pI9SDIwjzQCVhLdi/g7wiWhet3Lx0eMbhXREBScb6Y/+5WlkEZBCNY8n4wdoFv58r8OiEgzGAVlNDPrfET93TKZxfX3e/6BCRNRkGJCHtRFC6AESx5d3H6v4WB8ghT2iDo7zIRp3++7LKo0UJgTWTsKxgdDaPNkDgzdmpjU/SDMT79XlP6tyFu7N8JdZYXXw7jUkGdlcku162fLhl5OlYpUS1kKDO1lHSgQ319oWdWfAYHMESdSPu4VpTPU5nUEnUo0iRYpPxfFvJN95SX7GodfX08YKR8xmUhQwLRoPiiD2+Fvdw3h56Z9gldhz3z3y0xrTwbFVS4rvIGWLVAj3oZYZ5Y5CTC+PayooKyRMpMCJAhwucjpuESKPD60DPDPiGqrCySJf1WMTkNT3nueIqotK4FG7Q4OUqxc0MT/Z9Y9hbTSG6xU3dPoQmQIRLn+5aEntwwIfRMt89geGNS4mSHt266DCM0Y+OR4Yqi3AUVvwDaxzFhr5K8JScBiC93YPzy3qKCM1qJJQXIUKET35o7UVTxPbDfYy6EVdPcLAT7qJhsUwSytd8ihrRr3Cc05ZNg1+kCiF57YxLg/BTqbRM45t/Ug1NdABnOSBCcBOViVZgIm4knwgqcrJ5NOwUeRLqqOZ8Pf0wEtQLmY2v6QRiuSXPvZ/6qNl1ua5ykIvUqGOkOg6lm2LWJB8JAMhNAEhz8ggWE8DT4KOyeO6Co5CBype4DB3ec4bPjk+f/AQiWaA0qPjbOAAAAAElFTkSuQmCC"/>
              </defs>
              </svg>

              <div class="pt-6 pb-3">
                <strong class="text-lg">Google Ads</strong>
              </div>

              <p class="pt-3" style="color: rgba(0, 0, 0, 0.6); line-height: 25px;">
                View KPI's by campaign, ad group, keywords, ads and conversions for your clients' Google Ads and Local Service Ads account.
              </p>
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <div v-if="me.integrations.google_ads.status == 1">

            <button v-show="me.integrations.google_ads.settings.managers.length > 0 && me.lsa_command_enabled" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGoogleAds}" @click="saveGoogleAdsSettings();">
                SAVE
            </button>

            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_google_ads_popup = false">
                CLOSE
            </button>
          </div>
          <div v-else>
            <button v-show="me.lsa_command_enabled" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGoogleAds}" @click="connectGoogleAdsAccount">
                CONNECT ACCOUNT
            </button>

            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_google_ads_popup = false">
                CLOSE
            </button>
          </div>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_callrail_popup" @click.self="show_callrail_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          CallRail Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_callrail_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'">
              <div class="float-right -mt-1">
                <a href="https://www.loom.com/share/1d4766de85df4e90a1f550af06a76cf0?sid=b378d08b-ca15-4fe4-8d8b-c2970a5aa11d" style="font-size: 12px;"><i class="mdi mdi-information-outline" style="font-size: 14px;"></i> How to create CallRail API Key?</a>
              </div>
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_callrail_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.callrail.settings.api_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"

                @blur="saveCallRailSettings"
              />

              <a href="javascript: void(0);" @click="show_callrail_api_key = !show_callrail_api_key" class="token_password_toggle">
                <i v-if="show_callrail_api_key" class="mdi mdi-eye-outline"></i>
                <i v-if="!show_callrail_api_key" class="mdi mdi-eye-off-outline"></i>
              </a>
            </div>

            <template v-if="me.integrations.callrail.status == 1">
              <div :class="'w-full mb-3'">
                <p class="mb-1 text-xs mb-2"><strong>Select Account</strong></p>
                
                <v-autocomplete
                  v-model="me.integrations.callrail.settings.selected_account_id"
                  outlined dense
                  hide-details
                  :item-text="item => item.name"
                  :item-value="item => item.id"
                  :items="me.integrations.callrail.settings.available_accounts"
                  @change="saveCallRailSettings"
                  class="-mt-2"
                ></v-autocomplete>

                <p class="text-xs text-gray-600 pt-2">
                  Select your CallRail account.
                </p>
              </div>


              <div v-if="me.integrations.callrail.settings.selected_account_id && me.integrations.callrail.settings.available_phone_numbers.length > 0" class="flex flex-row flex-wrap">
                <div class="w-full sm:w-1/2 bg-white rounded-lg">
                  <div :class="'w-full mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>LSA Phone Numbers</strong></p>
                    <!-- <input :value="me.integrations.callrail.settings.phone_number" disabled class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                      :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                    /> -->

                    <div style="max-height: 300px; overflow: auto;">
                      <div v-for="(item, index) in me.integrations.callrail.settings.available_phone_numbers" :key="'tracking-number-' + index">
                        <v-checkbox v-model="me.integrations.callrail.settings.selected_phone_numbers" :value="item" :label="item + ((me.integrations.callrail.settings.numbers_names) ? ' - ' + me.integrations.callrail.settings.numbers_names[index] : '')"></v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w-full sm:w-1/2 bg-white rounded-lg">
                  <div :class="'w-full mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>SEO Phone Numbers</strong></p>
                    <div style="max-height: 300px; overflow: auto;">
                      <div v-for="(item, index) in me.integrations.callrail.settings.available_phone_numbers" :key="'tracking-number-' + index">
                        <v-checkbox v-model="me.integrations.callrail.settings.selected_phone_numbers_seo" :value="item" :label="item + ((me.integrations.callrail.settings.numbers_names) ? ' - ' + me.integrations.callrail.settings.numbers_names[index] : '')"></v-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="callrail_saved" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
                <div><strong>Settings Saved!</strong> Check the leads page after about 10 minutes to see your leads coming in.</div>
              </div>
            </template>
          </div>

          <div v-if="errorCallrail" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorCallrail"> </div>
          </div>

          <!-- <v-chip
            v-if="me.integrations.bland.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip> -->

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingCallrail}" @click="saveCallRailSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_callrail_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_ghl_popup" @click.self="show_ghl_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          GoHighLevel Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_ghl_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'" style="font-size: 12px;">
              <p class="mb-1 text-xs mb-2"><strong>Connection Type</strong></p>

              <label>
                <input type="radio" value="api" v-model="me.integrations.ghl.settings.mode" />
                Connect with API Key
              </label>
              
              <label class="ml-3">
                <input type="radio" value="oauth" v-model="me.integrations.ghl.settings.mode" />
                Connect with OAuth
              </label>

            </div>

            <div v-if="me.integrations.ghl.settings.mode === 'api'" :class="'w-full mb-3'">
              <div class="float-right -mt-1">
                <a href="https://help.gohighlevel.com/support/solutions/articles/48001205369-how-to-update-your-api-keys" style="font-size: 12px;"><i class="mdi mdi-information-outline" style="font-size: 14px;"></i> How to find or update GoHighLevel API Key?</a>
              </div>
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_ghl_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.ghl.settings.api_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <a href="javascript: void(0);" @click="show_ghl_api_key = !show_ghl_api_key" class="token_password_toggle">
                <i v-if="show_ghl_api_key" class="mdi mdi-eye-outline"></i>
                <i v-if="!show_ghl_api_key" class="mdi mdi-eye-off-outline"></i>
              </a>

              <p class="mb-1 text-xs mb-2 mt-2"><strong>API Key V2</strong></p>
              <input :type="'password'" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.ghl.settings.api_key_v2" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <p class="mb-1 text-xs mb-2 mt-2"><strong>Location ID</strong></p>
              <input :type="'password'" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.ghl.settings.location_id" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <template v-if="me.integrations.ghl.status == 1">
                <div v-if="ghl_saved" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
                  <div><strong>Settings Saved!</strong> Your leads will be sent to your GHL CRM.</div>
                </div>
              </template>
            </div>

            <div v-if="me.integrations.ghl.settings.mode === 'oauth'">
              <template v-if="me.integrations.ghl.settings.gohighlevel_access_token">
                <div class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
                  <div><strong>Account Connected!</strong> Your leads will be sent to your GHL CRM.</div>
                </div>
              </template>

              <button v-else class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" @click="redirectToGhlOAuth">
                CONNECT ACCOUNT
              </button>
            </div>
          </div>

          <div v-if="errorGhl" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorGhl"> </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button v-show="me.integrations.ghl.settings.mode" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGhl}" @click="saveGhlSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_ghl_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_calendly_popup" @click.self="show_calendly_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          Calendly Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_calendly_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">

            <div :class="'w-full mb-3'">
              <div class="float-right -mt-1">
                <a href="https://calendly.com/integrations/api_webhooks" style="font-size: 12px;" target="calendly-api-key"><i class="mdi mdi-information-outline" style="font-size: 14px;"></i> Get your Calendly API Key</a>
              </div>
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_calendly_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.calendly.settings.api_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <a href="javascript: void(0);" @click="show_calendly_api_key = !show_calendly_api_key" class="token_password_toggle">
                <i v-if="show_calendly_api_key" class="mdi mdi-eye-outline"></i>
                <i v-if="!show_calendly_api_key" class="mdi mdi-eye-off-outline"></i>
              </a>

              <template v-if="me.integrations.calendly.status == 1">
                <div v-if="calendly_saved" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
                  <div><strong>Settings Saved!</strong> Your leads will be sent to your Calendly CRM.</div>
                </div>
              </template>
            </div>
          </div>

          <div v-if="errorCalendly" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorCalendly"> </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingCalendly}" @click="saveCalendlySettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_calendly_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_dialpad_popup" @click.self="show_dialpad_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          DialPad Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_dialpad_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">

            <div :class="'w-full mb-3'">
              <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
              <input :type="((show_dialpad_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.dialpad.settings.api_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
              />

              <a href="javascript: void(0);" @click="show_dialpad_api_key = !show_dialpad_api_key" class="token_password_toggle">
                <i v-if="show_dialpad_api_key" class="mdi mdi-eye-outline"></i>
                <i v-if="!show_dialpad_api_key" class="mdi mdi-eye-off-outline"></i>
              </a>

              <template v-if="me.integrations.dialpad.status == 1">
                <div v-if="dialpad_saved" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
                  <div><strong>Settings Saved!</strong> Your leads will be sent to your DialPad CRM.</div>
                </div>
              </template>
            </div>
          </div>

          <div v-if="errorDialpad" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorDialpad"> </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingDialpad}" @click="saveDialpadSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_dialpad_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_crm_popup" @click.self="show_crm_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          CRM Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_crm_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'">
              <p class="mb-1 text-xs mb-2"><strong>Connection</strong></p>
              <v-radio-group
                class="mt-2"
              v-model="me.integrations.crm.settings.type"
              >
                <v-radio
                  :label="'Launch27'"
                  value="launch27"
                  on-icon="mdi-circle"
                  off-icon="mdi-circle-outline"
                  :ripple="false"
                ></v-radio>
                <v-radio
                  :label="'Service Titan'"
                  value="service_titan"
                  on-icon="mdi-circle"
                  off-icon="mdi-circle-outline"
                  :ripple="false"
                ></v-radio>
                <v-radio
                  :label="'House Call Pro'"
                  value="house_call_pro"
                  on-icon="mdi-circle"
                  off-icon="mdi-circle-outline"
                  :ripple="false"
                ></v-radio>
                <v-radio
                  v-show="!isAccelerate()"
                  :label="'FieldRoutes'"
                  value="field_routes"
                  on-icon="mdi-circle"
                  off-icon="mdi-circle-outline"
                  :ripple="false"
                ></v-radio>
              </v-radio-group>

              <div v-show="me.integrations.crm.settings.type == 'house_call_pro' || me.integrations.crm.settings.type == 'field_routes'">
              
                <p class="mb-1 text-xs mb-2"><strong>API Key</strong></p>
                <input :type="((show_crm_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.crm.settings.api_key" style="padding-right: 35px !important;"
                  :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                />

                <a href="javascript: void(0);" @click="show_crm_api_key = !show_crm_api_key" class="token_password_toggle">
                  <i v-if="show_crm_api_key" class="mdi mdi-eye-outline"></i>
                  <i v-if="!show_crm_api_key" class="mdi mdi-eye-off-outline"></i>
                </a>
              </div>

              <div v-show="me.integrations.crm.settings.type != 'house_call_pro' && me.integrations.crm.settings.type != 'field_routes'">

                <p class="mb-1 text-xs mb-2"><strong>Email</strong></p>
                <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.crm.settings.email" style="padding-right: 35px !important;"
                  :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                />
              
                <p class="mb-1 text-xs mb-2 mt-2"><strong>Password</strong></p>
                <input :type="((show_crm_api_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.crm.settings.password" style="padding-right: 35px !important;"
                  :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                />

                <a href="javascript: void(0);" @click="show_crm_api_key = !show_crm_api_key" class="token_password_toggle">
                  <i v-if="show_crm_api_key" class="mdi mdi-eye-outline"></i>
                  <i v-if="!show_crm_api_key" class="mdi mdi-eye-off-outline"></i>
                </a>
              </div>
            </div>

            <!-- <v-checkbox v-model="me.integrations.crm.settings.send_leads" :value="1" :label="'Send Leads'"></v-checkbox> -->

            <!-- &nbsp;&nbsp;&nbsp; -->

            <!-- <v-checkbox v-model="me.integrations.crm.settings.create_booking" :value="0" :label="'Create Booking'"></v-checkbox> -->

            <v-checkbox v-model="me.integrations.crm.settings.enable_budget_changes" :value="1" :label="'Enable Budget Changes'"></v-checkbox>

            <p class="text-xs text-gray-600">Reduce budget or pause campaign when the calendar is fully booked for the week.</p>

            <div v-show="me.integrations.crm.settings.enable_budget_changes" class="pr-2">
                <v-select
                  v-model="me.integrations.crm.settings.enable_budget_changes_action"
                  :items="['Pause Campaign', 'Reduce Budget']"
                  label="Action"
                  outlined dense
                />
            </div>

            <div v-show="me.integrations.crm.settings.enable_budget_changes && me.integrations.crm.settings.enable_budget_changes_action == 'Reduce Budget'" class="pl-2">
                <v-text-field
                  v-model="me.integrations.crm.settings.reduce_budget_percentage"
                  type="number"
                  label="Reduce Budget by %"
                  outlined dense
                />
            </div>

            <br clear="all" /><br clear="all" />
          </div>

          <template v-if="me.integrations.crm.status == 1">
            <div v-if="crm_saved" class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 mt-1" role="alert">
              <div><strong>Settings Saved!</strong>.</div>
            </div>
          </template>

          <div v-if="errorCrm" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorCrm"> </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingCrm}" @click="saveCrmSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_crm_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <!-- Email Edit Dialog -->
    <v-dialog v-model="showEmailEditDialog" max-width="600px" style="height: 596px;">
      <v-card>
        <v-card-title>Edit Email Template</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="emailData.filter_duration"
            type="number"
            label="Filter by duration (seconds)"
            outlined dense
          />

          <v-select
            v-model="emailData.filter_spam"
            :items="['all', 'yes', 'no']"
            label="Filter by Spam"
            outlined dense
          />

          <v-select
            v-model="emailData.filter_transferred"
            :items="['all', 'yes', 'no']"
            label="Filter by Transferred"
            outlined dense
          />

          <v-text-field
            v-model="emailData.subject"
            label="Subject"
            outlined
            dense
          />
          <v-textarea
            v-model="emailData.body"
            label="Body"
            rows="6"
            outlined
            dense
            style="font-size: 12px;"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 mr-2 float-right" @click="saveEmailTemplate()">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 float-right" @click="showEmailEditDialog = false">
              Cancel
          </button>
          
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="flex flex-row items-top justify-between">
      <h1 class="text-lg font-semibold mb-3">Settings</h1>
    </div>
    
    <hr class="border-b border-gray-100 mb-3">

    <div class="dashboard-box" v-if="me">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3 pt-1">

            <v-tabs>
              <v-tab>Profile</v-tab>
              <v-tab>Change Password</v-tab>
              <v-tab>Locations</v-tab>
              <v-tab>Users</v-tab>
              <!--<v-tab>Contacts</v-tab>-->
              <v-tab>Integrations</v-tab>
              <v-tab v-if="!isAccelerate()">Call Flow</v-tab>
              <v-tab>Notifications</v-tab>
              <v-tab v-show="$store.state.auth.owner || $store.state.auth.admin">Cost Management</v-tab>
              <v-tab v-if="!isOnlyAi()">License</v-tab>
              <v-tab>Video Tutorials</v-tab>
              <!-- <v-tab v-if="!isAccelerate()">Automations</v-tab> -->
              <v-tab>
                Survey

                <v-tooltip bottom color="#434C5E">
                    <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        🔒
                    </span>
                    </template>
                    <span>
                      Visible for admins only
                    </span>
                </v-tooltip>
              </v-tab>
              <v-tab>Blacklist</v-tab>
              <v-tab v-if="!isAccelerate()">Export Data</v-tab>

              <v-tab-item class="pt-5">
                <div class="flex flew-row flex-wrap">
                  <div class="rg-pic-wrapper w-full sm:w-1/4 pr-6 mb-4 mt-2" style="text-align: center; position: relative;">
                    <div v-if="profile">
                      <div v-if="profile.profile_image">
                        <img class="gravatar-pic" :src="profile.profile_image" />
                      </div>
                      <v-gravatar v-else class="gravatar-pic" :email="profile.email" default-img="https://lsaapi-uploads.s3.us-east-1.amazonaws.com/pics/default_profile.jpg" />
                    </div>
                      
                    <div class="rg-pic-uploader-wrapper" style="position: absolute; margin-top: -117px; left: calc(50% - 63px);">
                      <v-file-input
                        accept="image/*"
                        v-model="file"
                        @change="onUpload"
                        class="rg-uploader"
                        prepend-icon="mdi-camera"
                        outlined
                        hide-input
                      ></v-file-input>
                    </div>

                    <br />
                    <strong>{{ profile.first_name }} {{ profile.last_name }}</strong>
                  </div>
                  <div class="w-full sm:w-3/4 mb-4">
                    <div class="flex flew-row flex-wrap">
                      <div class="w-full sm:w-1/2 mb-4" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-6')">
                        <p class="mb-1 text-xs mb-2"><strong>First Name</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.first_name" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Last Name</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.last_name" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-6')">
                        <p class="mb-1 text-xs mb-2"><strong>Email</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.email" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Phone</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.phone" @input="phone_number_changed = true;" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-6')">
                        <p class="mb-1 text-xs mb-2"><strong>Address</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.address" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>City</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.city" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-6')">
                        <p class="mb-1 text-xs mb-2"><strong>State</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.state" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Zip Code</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.zip" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4" :class="(($vuetify.breakpoint.mobile) ? '' : 'pr-6')">
                        <p class="mb-1 text-xs mb-2"><strong>Company Name</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.company_name" />
                      </div>
                      <div class="w-full sm:w-1/2 mb-4">
                        <p class="mb-1 text-xs mb-2"><strong>Main Keyword</strong></p>
                        <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="profile.main_keyword" />
                      </div>
                      <div class="w-full mb-4">
                        <p class="mb-2 text-xs"><strong>Client timezone</strong></p>
                        <v-autocomplete v-model="me.timezone" :items="timezones" aria-label="Client timezone" outlined dense hide-details />
                        <p class="text-xs text-gray-600 pt-2">Choose the timezone for this client’s location.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <hr class="mt-3" />

                <div>
                  <div class="bg-purple float-right text-white text-sm inline-block rounded py-2 px-3 cursor-pointer mt-6" :class="{'spinner': saving}" @click="save()">Save</div>
                </div>
              </v-tab-item>

              <v-tab-item class="pt-5">
                <div class="w-full sm:w-1/3 pr-6 mb-4">
                  <p class="mb-1 text-xs mb-2"><strong>Current Password</strong></p>
                  <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="current_password" />
                </div>
                <div class="w-full sm:w-1/3 pr-6 mb-4">
                  <p class="mb-1 text-xs mb-2"><strong>New Password</strong></p>
                  <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="new_password" />
                </div>
                <div class="w-full sm:w-1/3 pr-6 mb-4">
                  <p class="mb-1 text-xs mb-2"><strong>Confirm Password</strong></p>
                  <input type="password" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" ref="confirm_password" />
                </div>

                <div v-if="error_password" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4" role="alert">
                  <div v-html="error_password"></div>
                </div>

                <hr class="mt-3" />

                
                <div class="float-right mt-6">

                  <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': changing}" @click="change_password">Change Password</div>
                </div>

                <div v-if="password_changed" class="float-left mt-4">
                  <v-chip
                    class="ma-2 mt-2 ml-3"
                    color="green"
                    outlined
                    @click="password_changed = false"
                    style="position: absolute;"
                  >
                    <v-icon left>
                      mdi-check
                    </v-icon>
                    Password changed!
                  </v-chip>
                </div>
              </v-tab-item>

              <v-tab-item class="pt-5">
                <LocationsStandalone />
              </v-tab-item>

              <v-tab-item class="pt-5">
                <UsersStandalone />
              </v-tab-item>

              <v-tab-item>
                <div v-if="me && me.integrations && me.integrations.google_ads" class="pt-3">

                  <h2 class="font-bold text-gray-800 mt-5">Google</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_google_ads_popup = true"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <svg class="lockup-ads-logo _ngcontent-awn-AWSM-2" enable-background="new 0 0 192 192" height="34" viewBox="0 0 192 192" width="34" xmlns="http://www.w3.org/2000/svg"><g class="_ngcontent-awn-AWSM-2"><rect fill="none" height="192" width="192" class="_ngcontent-awn-AWSM-2"></rect><g class="_ngcontent-awn-AWSM-2"><rect fill="#FBBC04" height="58.67" transform="matrix(0.5 -0.866 0.866 0.5 -46.2127 103.666)" width="117.33" x="8" y="62.52" class="_ngcontent-awn-AWSM-2"></rect><path d="M180.07,127.99L121.4,26.38c-8.1-14.03-26.04-18.84-40.07-10.74c-14.03,8.1-18.84,26.04-10.74,40.07 l58.67,101.61c8.1,14.03,26.04,18.83,40.07,10.74C183.36,159.96,188.16,142.02,180.07,127.99z" fill="#4285F4" class="_ngcontent-awn-AWSM-2"></path><circle cx="37.34" cy="142.66" fill="#34A853" r="29.33" class="_ngcontent-awn-AWSM-2"></circle></g></g></svg>
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 9px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">Google Ads</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        View KPI's by campaign, ad group, keywords, ads and conversions for your clients' Google Ads and Local Service Ads account.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me && me.integrations && me.integrations.google_ads && me.integrations.google_ads.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <!-- Google Business Profile Card -->
                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;"
                    @click="$router.push('/settings/gbp')"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <i class="mdi mdi-google-maps" style="font-size: 34px; color: #34A853;"></i>
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 9px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">Google Business Profile</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Manage your GBP reviews with AI-generated responses and enhance your business photos automatically.
                      </div>
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me && me.integrations && me.integrations.google_business_profile && me.integrations.google_business_profile.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>
                  <!-- End Google Business Profile Card -->

                  <h2 class="font-bold text-gray-800 mt-5">Call Tracking</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_callrail_popup = true"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <img :src="require('@/assets/images/callrail.png')" style="width: 40px;" />
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 19px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">CallRail</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Tracking and analytics for phone calls and web forms. Optimize your marketing and increase ROI on your PPC, SEO, and offline ad campaigns.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.callrail.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_dialpad_popup = true"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <img :src="require('@/assets/images/dialpad.png')" style="width: 40px;" />
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 19px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">DialPad</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        AI-powered communications platform with APIs for calls, SMS, and real-time insights.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.dialpad.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <h2 class="font-bold text-gray-800 mt-5">GHL</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="openGhlPopup()"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <img :src="require('@/assets/images/ghl.png')" style="width: 40px;" />
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 19px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">GoHighLevel</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        New leads are instantly synced to your GoHighLevel, keeping your data and automation up to date. We'll send: name, email, city, zip, tags, and source.

                        <div style="clear: both;"></div>
                      </div>
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.ghl.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <h2 class="font-bold text-gray-800 mt-5">Calendly</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="openCalendlyPopup()"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <img :src="require('@/assets/images/calendly.png')" style="width: 40px;" />
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 19px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">Calendly</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Integrate your calendly account to allow the AI automatically book your appointments.

                        <div style="clear: both;"></div>
                      </div>
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.calendly.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <h2 v-show="false" class="font-bold text-gray-800 mt-5">CRM</h2>

                  <div v-show="!isAccelerate()" class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="openCrmPopup()"
                    :style="(($vuetify.breakpoint.mobile) ? 'padding: 5px;' : '') + ((me.free_user) ? 'opacity: 0.4;' : '')"
                  >
                    <div style="float: left; width: 50px; padding-top: 7px; padding-left: 10px">
                      <img :src="require('@/assets/images/crm.png')" style="width: 40px;" />
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                        :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 180px); padding-left: 10px; padding-top: 19px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">CRM</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Connect your Launch27 or Service Titan API for automatic contacts and booking scheduling.

                        <div style="clear: both;"></div>
                      </div>
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.crm.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>
                </div>
              </v-tab-item>

              <v-tab-item v-if="!isAccelerate()">

                <div v-if="!me.convertly_enabled">
                  <product-access-required product="convertly" />
                </div>
                <div v-else>
                  <h2 class="font-bold text-gray-800 mt-5 mb-1">Call Flow Settings</h2>

                  <div class="pt-1 pb-1">
                    <a href="https://www.loom.com/share/31b2b1fd48654d69bf9d13bcd84926e1" target="lsa-help-video" style="font-size: 12px; margin-bottom: 5px;"><i class="mdi mdi-information-outline" style="font-size: 14px;"></i> How To Use The Call Flow System?</a>
                  </div>

                  <div v-if="call_flow">
                    <p class="text-xs text-gray-600 pt-2 pb-2">
                      Specify what happens when a call comes in to your phone number.
                    </p>

                    <v-radio-group v-model="call_flow.settings.call_flow_type">
                      <v-radio label="Dial AI -> Calls will always go directly to the AI" value="ai"></v-radio>
                      <v-radio label="Dial Phone Number -> All calls will be forwarded to a specific destination number" value="dial"></v-radio>
                      <v-radio label="Simulcall -> Multiple numbers can be dialed at once and whoever picks up first will get the call" value="simulcall"></v-radio>
                    </v-radio-group>

                    <div v-show="call_flow.settings.call_flow_type == 'dial'">
                      <div :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Destination Number</strong></p>

                        <input v-model="call_flow.settings.destination_number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify which number the call should be forwarded to.
                        </p>
                      </div>

                      <div :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Call Timeout</strong></p>

                        <input v-model="call_flow.settings.call_timeout" type="number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify how many seconds your intake will have to answer the call before being transferred to the AI
                        </p>
                      </div>

                      <br />

                      <v-radio-group v-model="call_flow.settings.what_happens_after_timeout">
                        <v-radio label="End call after timeout" value="end_call"></v-radio>
                        <v-radio label="Redirect to AI" value="redirect_ai"></v-radio>
                        <v-radio label="Redirect to a new phone number" value="redirect_to_new_number"></v-radio>
                      </v-radio-group>

                      <div v-show="call_flow.settings.what_happens_after_timeout == 'redirect_to_new_number'" :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Phone Number</strong></p>

                        <input v-model="call_flow.settings.phone_number_after_timeout" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify which number the call should be forwarded to after the timeout.
                        </p>
                      </div>
                    </div>

                    <div v-show="call_flow.settings.call_flow_type == 'simulcall'">
                      <div :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Enter Phone Numbers</strong></p>

                        <div v-for="(item, mn_index) in call_flow.settings.multiple_numbers">
                          <div class="flex flew-row flex-wrap mb-2 -mx-2">
                            <div class="w-full sm:w-1/2 px-2">
                              <input v-model="call_flow.settings.multiple_numbers[mn_index].name" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                label=""
                                placeholder="Enter a name for this number"
                                type="text"
                              />
                            </div>

                            <div class="w-full sm:w-1/2 px-2" style="position: relative;">
                              <input v-model="call_flow.settings.multiple_numbers[mn_index].phone_number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important;"
                                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                                label=""
                                placeholder="Phone number"
                                type="text"
                              />

                              <a href="javascript: void(0);" @click="deleteMultipleNumber(mn_index)" style="position: absolute; right: -11px; top: 9px;"><i class="mdi mdi-delete" style="color: red;"></i></a>
                            </div>
                          </div>
                        </div>

                        <a href="javascript: void(0);" style="font-size: 12px; margin-top: 10px;" @click="addMultipleNumber();">+ Add Number</a>

                        <p class="text-xs text-gray-600 pt-2">
                          Add Phone Numbers that will be dialed when a call comes in.
                        </p>
                      </div>

                      <div :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Weekend Phone Number (Optional)</strong></p>

                        <input v-model="call_flow.settings.weekend_number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                          placeholder="e.g. +1234567890"
                          type="text"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify a phone number to ring during weekends (Saturday and Sunday in America/New_York) instead of ringing all numbers above. If set, only this number will ring on weekends.
                        </p>
                      </div>

                      <div :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Call Timeout</strong></p>

                        <input v-model="call_flow.settings.call_timeout" type="number" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify how many seconds your intake will have to answer the call before being transferred to the AI
                        </p>
                      </div>

                      <br />

                      <v-radio-group v-model="call_flow.settings.what_happens_after_timeout">
                        <v-radio label="End call after timeout" value="end_call"></v-radio>
                        <v-radio label="Redirect to AI" value="redirect_ai"></v-radio>
                        <v-radio label="Redirect to a new phone number" value="redirect_to_new_number"></v-radio>
                      </v-radio-group>

                      <div v-show="call_flow.settings.what_happens_after_timeout == 'redirect_to_new_number'" :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Phone Number</strong></p>

                        <input v-model="call_flow.settings.phone_number_after_timeout" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify which number the call should be forwarded to after the timeout.
                        </p>
                      </div>
                    </div>

                    <br />

                    <v-checkbox v-model="call_flow.settings.business_hours_enabled" label="Business Hours"></v-checkbox>

                    <p class="text-xs text-gray-600">Enable business hours to identify during what times to follow instructions above.</p>

                    <div v-if="call_flow.settings.business_hours_enabled">
                      <business-hours :days="call_flow.settings.business_hours_list"></business-hours>

                      <br />

                      <v-radio-group v-model="call_flow.settings.what_happens_after_business_hours">
                        <v-radio label="Redirect to AI after business hours" value="redirect_ai"></v-radio>
                        <v-radio label="Redirect to a new phone number" value="redirect_to_new_number"></v-radio>
                      </v-radio-group>

                      <div v-show="call_flow.settings.what_happens_after_business_hours == 'redirect_to_new_number'" :class="'w-full lg:w-1/2 mb-3'">
                        <p class="mb-1 text-xs mb-2"><strong>Phone Number</strong></p>

                        <input v-model="call_flow.settings.phone_number_after_business_hours" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 40px;"
                          :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                        />

                        <p class="text-xs text-gray-600 pt-2">
                          Specify which number the call should be forwarded to after business hours.
                        </p>
                      </div>
                    </div>

                    <br /><br />

                    <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingCallFlow}" @click="saveCallFlow()">Save Changes</div>
                  </div>
                </div>
              </v-tab-item>

              <v-tab-item class="pt-5">
                <div class="mb-4 col-md-6">
                  <h2 class="font-bold text-gray-800 mb-1">Notifications Preferences</h2>

                  <a href="https://www.youtube.com/watch?v=a_hjRKaUUoI" target="lsa-help-video" style="font-size: 12px;"><i class="mdi mdi-information-outline" style="font-size: 14px;"></i> How to set up notifications in our software?</a>
                </div>

                <div class="w-full mb-2">
                  <v-tabs v-model="activeNotificationsTab">
                    <v-tab>Email</v-tab>
                    <v-tab>SMS</v-tab>
                    <v-tab>Outgoing Webhook</v-tab>
                    <v-tab>Incoming Webhook</v-tab>
                    
                    <v-tab-item class="pt-5">
                      <b-row class="mb-2 ml-1">
                        <b-col class="mt-3">
                            <span class="flex text-sm">
                              <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_email_enabled">
                              </v-switch>
                              Email
                            </span>
                          <label class="mt-4 text-sm">Enter Email Address</label> <br />
                          <v-combobox
                            v-model="me.settings.notifications_emails"
                            multiple
                            small-chips
                            color="blue"
                            outlined
                            dense
                            style="width: 600px"
                          ></v-combobox>
                        </b-col>
                      </b-row>
                    </v-tab-item>

                    <v-tab-item class="pt-5">
                      <b-row class="mb-2 ml-1">
                        <b-col class="mt-3">
                            <span class="flex text-sm">
                              <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_sms_enabled">
                              </v-switch>
                              SMS
                            </span>
                          <label class="mt-4 text-sm">Enter Phone Numbers</label> <br />
                          <v-combobox
                            v-model="me.settings.notifications_phone_numbers"
                            multiple
                            small-chips
                            color="blue"
                            outlined
                            dense
                            style="width: 600px"
                          ></v-combobox>
                        </b-col>
                      </b-row>
                    </v-tab-item>

                    <v-tab-item class="pt-5">
                      <b-row class="mb-2 ml-1">
                        <b-col class="mt-3 col-md-5">
                          <v-card class="pt-4">
                            <v-text-field
                              class="mb-2"
                              label="Webhook URL"
                              v-model="webhook.url"
                              placeholder="https://example.com/webhook"
                              outlined
                              hide-details
                            ></v-text-field>

                            <p class="text-xs mb-2" style="color: #757b89">
                              Enter the external endpoint that will receive POST requests from this platform for new leads.
                            </p>

                            <p class="mt-4 mb-1"><strong>Request Method:</strong> POST</p>

                            <p class="text-xs mb-2" style="color: #757b89">
                              We send requests via HTTP POST.
                            </p>

                            <p><strong>Example Payload:</strong></p>
                            <v-card class="pt-3 mb-2" outlined>
                              <pre style="max-height: 300px; overflow: auto; border: solid 1px #CCCCCC; border-radus: 5px; padding: 10px; font-size: 12px;">{{ examplePayload }}</pre>
                            </v-card>

                            <p class="text-xs mb-2" style="color: #757b89">
                              Sample body showing the fields we will send to your endpoint.
                            </p>

                            <div class="mt-4 d-flex">
                              <div class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-3 mr-2" :class="{'spinner': testingWebhook}" @click="testWebhook">
                                <span v-if="!testingWebhook">Test Webhook</span>
                                <span v-else>Testing...</span>
                              </div>
                              <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingWebhook}" @click="saveWebhook">
                                <span v-if="!savingWebhook">Save Webhook</span>
                                <span v-else>Saving...</span>
                              </div>
                            </div>

                            <div v-if="testResult" class="mt-4">
                              <h4>Test Result</h4>
                              <p><strong>Status:</strong> {{ testResult.status }}</p>
                              <p><strong>Response:</strong></p>
                              <v-card class="pt-3" outlined>
                                <pre>{{ testResult.data }}</pre>
                              </v-card>
                            </div>
                          </v-card>
                        </b-col>
                      </b-row>
                    </v-tab-item>

                    <v-tab-item class="pt-5">
                      <b-row class="mb-2 ml-1">
                        <b-col class="mt-3 col-md-7">
                          <v-card class="pt-4">
                            <v-text-field
                              class="mb-2"
                              label="Webhook URL"
                              value="https://ai.revulsab.com/send-sms"
                              outlined
                              readonly
                              hide-details
                            ></v-text-field>

                            <div style="float: right; margin-top: -69px; margin-right: 10px; position: relative;">
                              <v-tooltip bottom color="#434C5E">
                                  <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on">
                                      <a href="javascript: void(0);" v-clipboard:copy="'https://ai.revulsab.com/send-sms'" v-clipboard:success="onCopyWebhookUrl" v-clipboard:error="onError"><i class="mdi mdi-content-copy" style="font-size: 16px;"></i></a>
                                  </span>
                                  </template>
                                  <span>
                                  Copy Webhook URL
                                  </span>
                              </v-tooltip>
                            </div>

                            <p class="text-xs mb-2" style="color: #757b89">
                              Copy this URL and share it with external systems; they send POST requests to this platform here for sending outbound SMS.
                            </p>

                            <p class="mt-4 mb-1"><strong>Request Method:</strong> POST</p>

                            <p class="text-xs mb-2" style="color: #757b89">
                              Your integration must do POST requests to the URL above.
                            </p>

                            <p class="mt-4"><strong>Parameters:</strong></p>

                            <div class="mb-2" style="border: solid 1px #CCCCCC; padding: 15px; padding-top: 20px; border-radius: 10px;">
                              <code style="padding: 5px;">From</code>
                              <span class="text-xs text-gray-700 ml-2"> The AI Agent's number to send from</span>
                              <v-chip class="ma-2" x-small color="pink" text-color="white">required</v-chip>
                              <div class="mt-3"></div>

                              <code style="padding: 5px;">To</code>
                              <span class="text-xs text-gray-700 ml-2"> The customer phone number to send to</span>
                              <v-chip class="ma-2" x-small color="pink" text-color="white">required</v-chip>
                              <div class="mt-3"></div>

                              <code style="padding: 5px;">MessageType</code>
                              <span class="text-xs text-gray-700 ml-2"> The type of message, can be either "generated" or "custom"</span>
                              <v-chip class="ma-2" x-small color="pink" text-color="white">required</v-chip>
                              <div class="mt-3"></div>

                              <code style="padding: 5px;">Body</code>
                              <span class="text-xs text-gray-700 ml-2"> The exact message to send when message_type is "custom"</span>
                              <v-chip class="ma-2" x-small color="pink" text-color="white">required</v-chip>
                              <div class="mt-3"></div>

                              <code style="padding: 5px;">ApiToken</code>
                              <span class="text-xs text-gray-700 ml-2"> <strong>{{ $store.state.me.me.uuid }}</strong></span>
                              <v-chip class="ma-2" x-small color="pink" text-color="white">required</v-chip>
                              <div class="mt-3"></div>
                            </div>

                            <p class="text-xs mb-2" style="color: #757b89">
                              These are the required fields that callers must include in the incoming request.
                            </p>

                            <p class="mt-3"><strong>Example Response:</strong></p>
                            <v-card class="pt-1 mb-2" outlined>
                              <pre style="max-height: 300px; overflow: auto; border: solid 1px #CCCCCC; border-radus: 5px; padding: 10px; font-size: 12px;">{{ exampleResponse }}</pre>
                            </v-card>

                            <p class="text-xs mb-2" style="color: #757b89">
                              Sample JSON returned by this endpoint so callers know what to expect.
                            </p>

                            <div style="border: solid 1px #CCCCCC; padding: 15px; padding-top: 20px; border-radius: 10px;">
                              <code style="padding: 5px;">Status</code>
                              <span class="text-xs text-gray-700 ml-2"> Status of the SMS, can be "success" or "failed"</span>
                              <div class="mt-3"></div>

                              <code style="padding: 5px;">Error</code>
                              <span class="text-xs text-gray-700 ml-2"> The error message when the status is "failed"</span>
                              <div class="mt-3"></div>
                            </div>

                            <p class="mt-3"><strong>Test Webhook:</strong></p>
                            <v-text-field label="Webhook Payload" v-model="webhook_payload" outlined></v-text-field>

                            <div class="mt-1 d-flex">
                              <div class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-3 mr-2" :class="{'spinner': testingOutgoingWebhook}" @click="testOutgoingWebhook">
                                <span v-if="!testingOutgoingWebhook">Run Test</span>
                                <span v-else>Testing...</span>
                              </div>
                            </div>

                            <div v-if="testOutgoingResult" class="mt-4">
                              <h4>Test Completed</h4>
                              <p><strong>Response:</strong></p>
                              <v-card class="pt-3" outlined>
                                <pre>{{ testOutgoingResult }}</pre>
                              </v-card>
                            </div>
                          </v-card>
                        </b-col>
                      </b-row>
                    </v-tab-item>
                  </v-tabs> <!-- Closed v-tabs properly -->
                </div>

                <div class="pb-6 pl-3 flex">
                  <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.include_business_name_in_notifications">
                  </v-switch>
                  Include Business Name in Notifications
                </div>

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        LSA License and Insurance
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Send a notification when a license or insurance expires.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_license_expired">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        Missed Call
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification when a call is not answered.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_missed_call">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        Dropped Calls
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive notifications for dropped calls.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_dropped_call">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        New AI Lead
                        <v-icon
                          class="ml-2 cursor-pointer"
                          @click="openEditor('new_ai_lead')"
                          v-show="activeNotificationsTab == 0"
                        >
                          mdi-pencil
                        </v-icon>
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification for every incoming AI lead.
                        <br /><br />
                        <strong>Note:</strong> Message leads will be sent 5 minutes after the conversation started.
                        <br />
                        <strong>Note:</strong> Voice leads will be sent immediately at the end of the call.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_incoming_ai_lead">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        New AI Reply
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification for every incoming AI message reply.
                        <br /><br />
                        <strong>Note:</strong> This notification will be received for every incoming message, not just at the beginning of the conversation.
                        <br />
                        <strong>Note:</strong> This can result in multiple notifications per conversation.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_incoming_ai_reply">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        AI Call Ended Prematurely
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification for every incoming AI lead that ended prematurely by AI or by the prospect.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_incoming_ai_lead_ended_prematurely">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        New Web Chat Conversation
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification for every web chat conversation started.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_incoming_web_conversation">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        Customer Did Not Respond
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification when a customer hasn't replied after 1 hour.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_hasnt_replied_1_hour">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        Customer Responded
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a notification when a customer responded after an hour, conversation is active again.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_replied_1_hour">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        Business Phone Number (SMS only)
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Send a SMS notification to the lead to notify them what business phone number they will receive a call from.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_business_phone_number">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        AI Report
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive an email report with your latest leads — including a CSV attachment and a visual summary.
                      </p>
                    </div>

                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">Receive Report:</h1>
                      <v-checkbox v-model="me.settings.ai_report_daily_enabled" label="Daily"></v-checkbox>
                      <v-checkbox v-model="me.settings.ai_report_weekly_enabled" label="Weekly"></v-checkbox>
                      <v-checkbox v-model="me.settings.ai_report_monthly_enabled" label="Monthly"></v-checkbox>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_daily_ai_report">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="mb-2">
                  <b-col md="5">
                    <div class="w-full pr-6 mb-2 mt-4 pl-3">
                      <h1 class="mb-4 text-sm" style="font-weight: bolder">
                        LSA Report
                      </h1>
                      <p class="mb-1 text-xs mb-2" style="color: #757b89">
                        Receive a monthly LSA report including survey submissions, refunds and lead quality.
                      </p>
                    </div>
                  </b-col>
                  <b-col class="pl-8">
                    <div class="flex mt-10 flxmtten">
                        <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.notifications_monthly_lsa_report">
                        </v-switch>
                    </div>
                  </b-col>
                </b-row>

                <hr class="mt-3" />

                <div class="float-right mt-6">
                  <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save Changes</div>
                </div>
              </v-tab-item> 

              <v-tab-item v-show="$store.state.auth.owner || $store.state.auth.admin" class="pt-5">
                <!-- Cost Management Tab -->
                <v-card flat class="pa-4" style="max-width: 700px;">
                  <v-alert v-if="costError" type="error" dense>{{ costError }}</v-alert>

                  <strong class="text-sm">SEO Investment:</strong>

                  <input type="number" v-model="me.settings.seo_investment" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100%; margin-top: 5px; margin-bottom: 10px;"
                    :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                  />

                  <strong class="text-sm">Monthly LSA Credits:</strong>

                  <div v-if="costs.length" style="max-height: 700px; overflow-y: scroll;">
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Gross Adspend</th>
                          <th style="text-align: left !important;">Credits</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="cost in costs" :key="cost.id">
                          <td>{{ cost.month }}</td>
                          <td>{{ cost.cost }}</td>
                          <td class="pt-2 pb-2">
                            <input type="number" v-model="cost.credits" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; width: 100%;"
                              :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <v-alert v-else type="info" dense>No cost data available.</v-alert>

                  <hr v-if="costs.length" class="mt-3" />

                  <div v-if="costs.length" class="float-right mt-6">
                    <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="saveCosts">Save Costs</div>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item v-if="!isOnlyAi()" class="pt-5" style="overflow: auto;">
                <table class="w-full rg-datatable datatable">
                  <thead class="border-b border-gray-100 w-full">
                    <tr class="tableHeader">
                      <th>Verification Type</th>
                      <th>Creation Date</th>
                      <th>Status</th>
                      <th style="width: 500px;">Details</th>
                    </tr>
                  </thead>
                  <tbody class="w-full" style="">
                    <tr v-for="(license, index) in licenses" :key="'license-' + index">
                      <td>
                        <span v-if="license.getArtifactType == 0">
                          Unspecified
                        </span>

                        <span v-if="license.getArtifactType == 1">
                          Unknown
                        </span>

                        <span v-if="license.getArtifactType == 2">
                          Background Check
                        </span>

                        <span v-if="license.getArtifactType == 3">
                          Insurance
                        </span>

                        <span v-if="license.getArtifactType == 4">
                          License
                        </span>

                        <span v-if="license.getArtifactType == 5">
                          Business Verification
                        </span>
                      </td>
                      <td>
                        {{ formatDate(license.getCreationDateTime) }}
                      </td>
                      <td>
                        <v-chip v-if="license.getStatus == 0" color="grey" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">UNSPECIFIED</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 1" color="grey" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">UNKNOWN</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 2" color="green" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">APPROVED</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 3" color="red" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">FAILED</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 4" color="purple" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">PENDING</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 5" color="grey" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">NO_SUBMISSION</span>
                        </v-chip>

                        <v-chip v-if="license.getStatus == 6" color="orange" small>
                            <span style="color: #FFFFFF; font-size: 12px; font-weight :bold;">CANCELLED</span>
                        </v-chip>
                      </td>
                      <td>
                        <div v-if="license.getArtifactType == 2" style="font-size: 12px; line-height: 22px;">
                          <strong>Final adjudication Time: </strong>
                          {{ formatDate(license.getBackgroundCheckVerificationArtifact.getFinalAdjudicationDateTime) }}
                          <br />
                          <strong>Case URL: </strong>
                          <a :href="'https://' + license.getBackgroundCheckVerificationArtifact.getCaseUrl" target="lsa-bg-check-url">View Case</a>
                          <br />
                        </div>

                        <div v-if="license.getArtifactType == 3" style="font-size: 12px; line-height: 22px;">
                          <strong>Amount: </strong>
                          ${{ (license.getInsuranceVerificationArtifact.getAmountMicros/1000000).toLocaleString() }}
                          <br />
                          <strong>Document URL: </strong>
                          <a :href="license.getInsuranceVerificationArtifact.getInsuranceDocumentReadonly.getDocumentUrl" target="lsa-bg-check-url">View Case</a>
                          <br />
                        </div>

                        <div v-if="license.getArtifactType == 4" style="font-size: 12px; line-height: 22px;">

                          <strong>License Number:</strong> {{ license.getLicenseVerificationArtifact.getLicenseNumber }}
                          <br />
                          <strong>License Type:</strong> {{ license.getLicenseVerificationArtifact.getLicenseType }}
                          <br />
                          <strong>First Name:</strong> {{ license.getLicenseVerificationArtifact.getLicenseeFirstName }}
                          <br />
                          <strong>Last Name:</strong> {{ license.getLicenseVerificationArtifact.getLicenseeLastName }}
                          <br />
                          <strong>Rejection Reason:</strong>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 0">
                            Not specified.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 1">
                            Unknown.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 2">
                            Business name doesn't match business name for the Local Services Ad.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 3">
                            License is unauthorized or been revoked.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 4">
                            License is expired.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 5">
                            License is poor quality - blurry images, illegible, etc...
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 6">
                            License cannot be verified due to a not legitimate image.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 7">
                            License is not the requested document type or contains an invalid ID.
                          </span>

                          <span v-if="license.getLicenseVerificationArtifact.getRejectionReason == 8">
                            License has another flaw not listed explicitly.
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-tab-item>

              <v-tab-item class="pt-5">
                <Videos />
              </v-tab-item>

              <!-- <v-tab-item v-if="!isAccelerate()" class="pt-5" style="overflow: auto;">
                  <TriggerActionsManager />
              </v-tab-item> -->

              <v-tab-item class="pt-5" style="overflow: auto;">
                <div v-if="!me.lsa_command_enabled">
                  <product-access-required product="lsa_command" />
                </div>
                <div v-else>
                  <h2 class="font-bold text-gray-800 mt-5 mb-1">Survey Settings</h2>
                  <video-guide ids="qualification" label="High-value lead rules" />

                  <v-alert
                    type="info"
                    dense
                    text
                    class="text-xs w-full lg:w-1/2 mt-3 mb-4"
                  >
                    <strong>Note:</strong> onfiguration changes made here regarding survey and high-value lead decisions will apply exclusively to newly ingested leads and will not affect existing records in the system.
                  </v-alert>

                   <div v-show="!isAccelerate()" :class="'w-full lg:w-1/2 mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>Enabled</strong></p>

                    <div class="pl-1">
                      <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="me.settings.auto_survey_enabled"></v-switch>
                    </div>

                    <p class="text-xs text-gray-600 pt-2">
                      Allow AI to automatically submit surveys to Google LSA.
                    </p>
                  </div>

                  <div v-show="!isAccelerate()" :class="'w-full lg:w-1/2 mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>Survey AI Prompt:</strong></p>

                    <textarea v-model="me.integrations.bland.settings[0].survey_prompt" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 140px;"
                      :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                    ></textarea>

                    <p class="text-xs text-gray-600 pt-2">
                      Initial survey prompt.
                    </p>
                  </div>

                  <div :class="'w-full lg:w-1/2 mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>Survey Satisfied/High Value Lead Instructions:</strong></p>

                    <textarea v-model="me.settings.auto_survey_services" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 140px;"
                      :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                    ></textarea>

                    <p class="text-xs text-gray-600 pt-2">
                      Let the AI know what services and service areas it should mark leads as satisfied. Any lead whose job type, summary, or comments match these entries will also be marked as High Value in the dashboard views.
                    </p>
                  </div>

                  <div :class="'w-full lg:w-1/2 mb-3'">
                    <p class="mb-1 text-xs mb-2"><strong>Survey Dissatisfied Instructions:</strong></p>

                    <textarea v-model="me.settings.auto_survey_non_services" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 140px;"
                      :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                    ></textarea>

                    <p class="text-xs text-gray-600 pt-2">
                      Let the AI know what services and service areas it should mark leads as dissatisfied for.
                    </p>
                  </div>

                  <hr class="mt-3" />

                  <div class="float-right mt-6">
                    <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save Changes</div>
                  </div>
                </div>
              </v-tab-item>

              <v-tab-item class="pt-5" style="overflow: auto;">
                <h2 class="font-bold text-gray-800 mt-5 mb-1">Blacklist</h2>

                <div :class="'w-full lg:w-1/2 mb-3'">
                  <p class="mb-1 text-xs mb-2"><strong>Blacklisted Phone Numbers:</strong></p>

                  <textarea v-model="me.settings.blacklisted_numbers" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 140px;"
                    :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"
                    placeholder="+12345678901,+12345678902,+12345678903"
                  ></textarea>

                  <p class="text-xs text-gray-600 pt-2">
                    Blacklisted numbers will not be allowed to dial or text your AI number. Add as many numbers as you like, comma separated, in international format.
                  </p>
                </div>

                <hr class="mt-3" />

                <div class="float-right mt-6">
                  <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save Changes</div>
                </div>
              </v-tab-item>

              <v-tab-item v-if="!isAccelerate()" class="pt-5" style="overflow: auto;">
                  <ExportData />
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card>

    </div>



  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import TriggerActionsManager from '@/components/triggers/TriggerActionsManager.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import TestingSuiteStandalone from '@/views/panel/TestingSuiteStandalone.vue'
import LocationsStandalone from '@/views/panel/LocationsStandalone.vue'
import UsersStandalone from '@/views/panel/UsersStandalone.vue'
import Videos from '@/views/panel/Videos.vue'
import BuyNumber from '@/components/dialogs/integrations/buyNumber.vue'
import InboxThread from '@/views/panel/InboxThread.vue'
import ExportData from '@/views/panel/Call/ExportData.vue'
import moment from 'moment-timezone'
import BusinessHours from 'vue-business-hours';
import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'

import exampleData from "@/assets/webhook/example.json";

export default {
  metaInfo () {
    return {
      title: "Settings | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    ToggleButton,
    TriggerActionsManager,
    TestingSuiteStandalone,
    LocationsStandalone,
    UsersStandalone,
    BuyNumber,
    InboxThread,
    BusinessHours,
    Videos,
    ExportData,
    ProductAccessRequired
  },
  data() {
    return {
      timezones: moment.tz.names(),
      userSegmentation: false,
      panel: [0],
      saving: false,

      changing: false,
      error_password: null,
      password_changed: false,

      phone_number_changed: false,
      show_phone_verification_modal: false,

      phone: "",
      phone_valid: false,
      verifying_otp: false,
      otp_valid: false,
      otp_attempted: false,
      otp_generated_code: null,

      error: null,
      getReviewsCampaignLoaded: false,
      getReviewsCampaign: null,
      file: null,

      savingTwilio: false,
      errorTwilio: null,
      gettingTwilioNumbers: false,
      show_auth_token: false,

      show_google_ads_popup: false,

      savingGoogleAds: false,
      errorGoogleAds: null,

      show_callrail_popup: false,
      savingCallrail: false,
      errorCallrail: null,
      callrail_saved: false,

      show_callrail_api_key: false,

      show_ghl_popup: false,
      savingGhl: false,
      errorGhl: null,
      ghl_saved: false,

      show_ghl_api_key: false,

      show_calendly_popup: false,
      savingCalendly: false,
      errorCalendly: null,
      calendly_saved: false,

      show_calendly_api_key: false,

      show_dialpad_popup: false,
      savingDialpad: false,
      errorDialpad: null,
      dialpad_saved: false,

      show_dialpad_api_key: false,

      show_crm_popup: false,
      savingCrm: false,
      errorCrm: null,
      crm_saved: false,

      show_crm_api_key: false,

      seconds_to_answer_options: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60],

      testingSuiteStandaloneVoiceKey: 0,
      testingSuiteStandaloneSMSKey: 0,

      licenses: [],

      playingVoice: false,

      comparisons: {},

      knowledgebase_file: null,
      uploading_knowledgebase: false,

      voice_sounds: {
        "alloy": "https://cdn.openai.com/API/docs/audio/alloy.wav",
        "ash": "https://web.opendrive.com/api/v1/download/file.json/MjRfNjUxNjU2NDNf?temp_key=%DB%8Dt%DF%5Dx%D7%ADuj%C8f%A7&inline=1",
        "ballad": "https://web.opendrive.com/api/v1/download/file.json/MjRfNjUxNjU2NDVf?temp_key=%DB%8Dt%DF%5Dx%D7%7E%3Cm%A9ei%D9%A9&inline=1",
        "coral": "https://web.opendrive.com/api/v1/download/file.json/MjRfNjUxNjU2NDFf?temp_key=%DB%8Dt%DF%5Dx%D7%AEwr%8A%DA%96jw&inline=1",
        "echo": "https://cdn.openai.com/API/docs/audio/echo.wav",
        "sage": "https://web.opendrive.com/api/v1/download/file.json/MjRfNjUxNjU2Mzhf?temp_key=%DB%8Dt%DF%5Dx%D7%BD%F9%B1%A8%1E%9A%9D&inline=1",
        "shimmer": "https://cdn.openai.com/API/docs/audio/shimmer.wav",
        "verse": "https://cdn.openai.com/API/docs/audio/alloy.wav"
      },

      show_a2p_form: false,

      a2p_data: {
        business_name: "",
        ein: "",
        phone: "",
        address: "",
        email: "",
        type: "",
        website: "",
        owner_name: "",
        owner_phone: "",
        owner_email: ""
      },

      errorA2P: null,
      submittingA2P: false,

      transfer_list: [],

      previewEmbed: 0,
      previewEmbedFloating: 0,

      bot_details: {},
      shareableLink: "",

      savingCallFlow: false,
      call_flow: {
        settings: {
          call_flow_type: 'ai',
          destination_number: '',
          call_timeout: 10,
          what_happens_after_timeout: 'end_call',
          phone_number_after_timeout: '',
          multiple_numbers: [],
          weekend_number: '',
          business_hours_enabled: false,
          business_hours_list: [],
          what_happens_after_business_hours: 'redirect_ai',
          phone_number_after_business_hours: ''
        }
      },

      business_hours_list: {
        sunday: [
          {
            open: '',
            close: '',
            id: '5ca5578b0c5c7',
            isOpen: false
          }
        ],
        monday: [
          {
            open: '0800',
            close: '1700',
            id: '5ca5578b0c5d1',
            isOpen: true
          }
        ],
        tuesday: [
          {
            open: '0800',
            close: '1700',
            id: '5ca5578b0c5d8',
            isOpen: true
          }
        ],
        wednesday: [
          {
            open: '0800',
            close: '1700',
            id: '5ca5578b0c5df',
            isOpen: true
          }
        ],
        thursday: [
          {
            open: '0800',
            close: '1700',
            id: '5ca5578b0c5e6',
            isOpen: true
          }
        ],
        friday: [
          {
            open: '0800',
            close: '1700',
            id: '5ca5578b0c5ec',
            isOpen: true
          },
          {
            open: '1900',
            close: '2200',
            id: '5ca5578b0c5f2',
            isOpen: true
          }
        ],
        saturday: [
          {
            open: '24hrs',
            close: '24hrs',
            id: '5ca5578b0c5f8',
            isOpen: true
          }
        ]
      },

      lsa_accounts: [],

      costs: [],
      costError: null,

      activeNotificationsTab: 0, // keep your existing default if already set
      webhook: {
        url: "",
      },
      examplePayload: JSON.stringify(exampleData, null, 2),

      exampleResponse: '{"status": "success", "From": "+1111111111", "To": "+12222222222", "MessageSent": "Example message here...", "error": ""}',

      testResult: null,

      testingWebhook: false,
      savingWebhook: false,

      webhook_payload: '{"From": "+11111111111", "To": "+12222222222", "MessageType": "generated", "Body": "", "ApiToken": ""}',

      testOutgoingResult: "",

      testingOutgoingWebhook: false,
      savingOutgoingWebhook: false,

      showEmailEditDialog: false,
      currentTemplate: null, // which email template we're editing
      emailData: {
        subject: "",
        body: "",
        filter_duration: 0,
        filter_spam: "all",        // default option
        filter_transferred: "all"  // default option
      }
    }
  },
  methods: {
    async openEditor(templateKey) {
      this.currentTemplate = templateKey;
      this.showEmailEditDialog = true;

      try {
        // fetch default subject/body from backend
        const res = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/email-templates/${templateKey}`, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        this.emailData.subject = res.data.subject || "";
        this.emailData.body = res.data.body || "";
      } catch (error) {
        console.error("Failed to fetch template:", error);
      }
    },
    async saveEmailTemplate() {
      this.$swal({
        title: "Saved",
        text: "Email template saved successfully!",
        icon: "success",
        showCancelButton: false,
      });

      try {
        await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/email-templates/${this.currentTemplate}`, {
          subject: this.emailData.subject,
          body: this.emailData.body
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        this.showEmailEditDialog = false;
      } catch (error) {
        console.error("Failed to save template:", error);
      }
    },

    async testWebhook() {
      this.testingWebhook = true;
      this.testResult = null;

      try {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/webhooks/test`, {
          url: this.webhook.url,
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        this.testResult = response.data;

        this.$swal({
          title: "Test Completed",
          text: `Webhook responded with status ${response.data.status}`,
          icon: response.data.successful ? "success" : "error",
        });
      } catch (error) {
        this.testResult = {
          status: error.response.status || "Error",
          data: error.response.data || error.message,
        };

        this.$swal({
          title: "Test Failed",
          text: error.message,
          icon: "error",
        });
      }
      this.testingWebhook = false;
    },

    async saveWebhook() {
      this.savingWebhook = true;
      try {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/webhooks/save`, {
          url: this.webhook.url,
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        this.$swal({
          title: "Saved",
          text: "Webhook URL saved successfully!",
          icon: "success",
          showCancelButton: false,
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to save webhook.",
          icon: "error",
          showCancelButton: false,
        });
      }

      this.savingWebhook = false;
    },

    async testOutgoingWebhook() {
      this.testingOutgoingWebhook = true;
      this.testOutgoingResult = "";

      let response = await axios.post(`https://ai.revulsab.com/send-sms`, JSON.parse(this.webhook_payload), {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      });
      this.testOutgoingResult = response.data;
      this.testingOutgoingWebhook = false;
    },

    async fetchWebhook() {
      this.loadingWebhook = true;
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/webhooks/get`, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        if (response.data.webhook) {
          this.webhook.url = response.data.webhook.url;
        }
      } catch (error) {
        this.$swal({
          title: "Error",
          text: "Failed to load webhook.",
          icon: "error",
        });
      } finally {
        this.loadingWebhook = false;
      }
    },
    
    redirectToGhlOAuth() {
      window.location.href = this.getGhlOAuthUrl();
    },

    getGhlOAuthUrl() {
      return `https://lsa.ravu.me/hl/redirect?uuid=` + this.me.uuid + `&frurl=` + window.location.href + encodeURIComponent("?ghl_connected=true");
    },

    async fetchCosts() {
      try {
        this.costError = null;
        const res = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get_cost`, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        if (res.data.success) {
          this.costs = res.data.costs;
        } else {
          this.costError = 'Failed to load cost data.';
        }
      } catch (err) {
        this.costError = 'Error fetching cost data.';
        console.error(err);
      }
    },

    async saveCosts() {
      this.saving = true

      try {
        const res = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/save_costs`, { costs: this.costs, seo_investment: this.me.settings.seo_investment }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        if (res.data.success) {
          this.$swal({
            title: "Saved",
            text: "Credits updated successfully!",
            showCancelButton: false,
          });
        } else {
          this.costError = 'Failed to save cost data.';
        }
      } catch (err) {
        this.costError = 'Error saving cost data.';
        console.error(err);
      }

      this.saving = false
    },

    getHost() {
      return window.location.host;
    },

    isOnlyAi() {
      if (this.me.integrations && this.me.integrations.google_ads && this.me.integrations.google_ads.status == 0)
        return true;

      return false;
    },

    isAccelerate() {
      // || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
      // || this.getHost() == 'localhost:8080'
      return this.getHost() == 'lsa.accelerateyourmarketing.com';
    },

    async getLsaAccounts() {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/get-lsa-accounts`, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
            'Content-Type': 'multipart/form-data'
          }
      })

      console.log('response', response);
      this.lsa_accounts = response.data.lsa_accounts;
    },

    refreshLsaAccountsList() {
      if (this.me.integrations.google_ads.settings.selected_manager_id === 0) {
        this.getLsaAccounts();
      }
      else {
        this.lsa_accounts = JSON.parse(JSON.stringify(this.me.integrations.google_ads.settings.original_managers[this.me.integrations.google_ads.settings.selected_manager_id].clients));
      }
    },

    async getBotDetails() {
          let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/inbox/get-bot-data?u=' + this.me.uuid + '&p=' + this.me.integrations.bland.settings[this.selected_bland_number].phone_number, {
              headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              },
          })

          this.bot_details = response.data.bot_data;
      },

      getShareableLink() {
        this.shareableLink = window.location.origin + `/chat?u=` + this.me.uuid + `&p=` + this.me.integrations.bland.settings[this.selected_bland_number].phone_number;
      },
      
      getEmbedCode() {
        return `<style>
iframe#acc-lsa-widget { width: 100%; height: 100%; min-height: 500px; border: solid 1px #CCCCCC !important; }
@media (max-width: 768px) { iframe#acc-lsa-widget { height: 60vh; min-height: 59vh; } }
</style> </head> <body>

<iframe id="acc-lsa-widget" src="` + window.location.origin + `/chat?u=` + this.me.uuid + `&p=` + this.me.integrations.bland.settings[this.selected_bland_number].phone_number + `"></iframe>`;
      },


      getEmbedCodeFloating() {
        return `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">
<style>
iframe#acc-lsa-widget { display: none; width: 450px; height: 550px; border: solid 1px #CCCCCC !important; position: absolute; right: 0px; bottom: 0px; margin-right: 15px; margin-bottom: 90px; }
@media (max-width: 768px) { iframe#acc-lsa-widget { height: calc(100% - 80px); } }
.ls-floating-button {border-radius: 10px;background: #3a9bdb;width: ;position: absolute;right: 0px;bottom: 0px;margin-right: 15px;margin-bottom: 15px;width: 60px;height: 46px;text-align: center;padding-top: 15px;cursor: pointer;}

.ls-floating-button.close {display: none;color: #FFFFFF; font-size: 20px; height: 49px; padding-top: 12px;}
</style>

<iframe id="acc-lsa-widget" src="` + window.location.origin + `/chat?u=` + this.me.uuid + `&p=` + this.me.integrations.bland.settings[this.selected_bland_number].phone_number + `&fl=1"></iframe>
<div class="ls-floating-button" onclick="document.querySelector('.ls-floating-button').style.display = 'none'; document.querySelector('.ls-floating-button.close').style.display = 'block'; document.querySelector('#acc-lsa-widget').style.display = 'block';"><i class="mdi mdi-message-text-outline" style="font-size: 30px; color: #FFFFFF;"></i></div>
<div class="ls-floating-button close" onclick="document.querySelector('.ls-floating-button').style.display = 'block'; document.querySelector('.ls-floating-button.close').style.display = 'none'; document.querySelector('#acc-lsa-widget').style.display = 'none';"><i class="mdi mdi-close" style="font-size: 35px; color: #FFFFFF;"></i></div>`;
      },

      openGhlPopup() {
        this.show_ghl_popup = true
      },

      openCalendlyPopup() {
        this.show_calendly_popup = true
      },

      openCrmPopup() {
        if (false) { } else { this.show_crm_popup = true }
      },

      deleteKnowledgebaseFile(index) {
        let newFiles = [];

        for (var i in this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_files) {
          if (i != index)
            newFiles.push(this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_files[i]);
        }

        this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_files = newFiles;
      },

      deleteKnowledgebaseWebsite(index) {
        let newWebsites = [];

        for (var i in this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_websites) {
          if (i != index)
            newWebsites.push(this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_websites[i]);
        }

        this.me.integrations.bland.settings[this.selected_bland_number].knowledgebase_websites = newWebsites;
      },

      deleteTransferList(index) {
        let newTl = [];

        for (var i in this.transfer_list) {
          if (i != index)
            newTl.push(this.transfer_list[i]);
        }

        this.transfer_list = newTl;
      },

      deleteMultipleNumber(mn_index) {
        let newMn = [];

        for (var i in this.call_flow.settings.multiple_numbers) {
          if (i != mn_index)
            newMn.push(this.call_flow.settings.multiple_numbers[i]);
        }

        this.call_flow.settings.multiple_numbers = newMn;
      },

      async onUploadKnowledgebase() {
      // console.log(this.file);
      if (this.knowledgebase_file !== null) {
        this.uploading_knowledgebase = true
        let formData = new FormData()

        console.log('this.knowledgebase_file', this.knowledgebase_file);

        for (var i in this.knowledgebase_file) {
          formData.append("file[" + i + "]", this.knowledgebase_file[i])
        }

        formData.append('phone_number', this.me.integrations.bland.settings[this.selected_bland_number].phone_number);

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/upload-knowledgebase`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })
          
          this.me.integrations.bland.settings = response.data.settings;
        }catch(e){
          console.log(e)
        }

        this.knowledgebase_file = null
        this.uploading_knowledgebase = false
      }
    },

    selectPrompt() {
      this.me.integrations.bland.settings[this.selected_bland_number].prompt_v2 = this.me.integrations.bland.settings[this.selected_bland_number].prompt_choices[this.me.integrations.bland.settings[this.selected_bland_number].prompt_v2_selection];
    },

    playVoiceNew() {
      try {
        document.getElementById('playVoiceMp3').remove();
      }
      catch (e) {}

      let self = this;

      self.playingVoice = true;

      var audio = new Audio();
      audio.id = 'playVoiceMp3';
      audio.src = this.voice_sounds[this.me.integrations.bland.settings[this.selected_bland_number].voice_v2];
      audio.controls = true;
      audio.autoplay = true;
      document.body.appendChild(audio);

      audio.addEventListener('ended', function(e) {
        document.getElementById('playVoiceMp3').remove();
        self.playingVoice = false;
      }, false);
    },

    getIdFromBlandNumberSelect() {
      this.selected_bland_number = this.me.integrations.bland.settings.findIndex(x => x.phone_number=== this.blandNumberSelected.phone_number);

      this.setTransferList();
      this.getBotDetails();
    },

    setTransferList() {
      this.transfer_list = [];

      for (var i in this.me.integrations.bland.settings[this.selected_bland_number].transfer_list) {
        this.transfer_list.push({
          name: i,
          phone_number: this.me.integrations.bland.settings[this.selected_bland_number].transfer_list[i]
        })
      }
    },

    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    addWord() {
      this.me.integrations.bland.settings[this.selected_bland_number].pronunciation_guide.push({
        "word": "",
        "pronunciation": "",
        "case_sensitive": "false",
        "spaced": "false"
      });
    },

    addNumber() {
      this.transfer_list.push({
        name: "",
        phone_number: ""
      })
    },

    addMultipleNumber() {
      this.call_flow.settings.multiple_numbers.push({
        name: "",
        phone_number: ""
      })
    },

    async onUpload() {
      // console.log(this.file);
      if (this.file !== null) {
        this.uploading = true
        let formData = new FormData()
        formData.append("file", this.file)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-profile-picture`, {
            profile_image: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.profile.profile_image = response.data.url

        }catch(e){
          console.log(e)
        }

        this.file = null
        this.uploading = false
      }
    },

    onCopy: function (e) {
      this.$swal({
        title: "Copied",
        text: "LSA Profile URL copied successfully!",
        showCancelButton: false,
      });
    },
    onError: function (e) {
      alert('Failed to copy the URL to the clipboard')
      console.log(e);
    },

    onCopyWebhookUrl: function (e) {
      this.$swal({
        title: "Copied",
        text: "Webhook URL copied successfully!",
        showCancelButton: false,
      });
    },
    onError: function (e) {
      alert('Failed to copy the URL to the clipboard')
      console.log(e);
    },

    onCopyAiNumber: function (e) {
      this.$swal({
        title: "Copied",
        text: "Phone number copied successfully!",
        showCancelButton: false,
        });
    },
    onErrorAiNumber: function (e) {
      alert('Failed to copy the phone number to the clipboard')
      console.log(e);
    },
    sendOtpSms() {
      let self = this;

      self.verifying_otp = false;
      self.otp_valid = false;
      self.otp_attempted = false;

      self.$refs.otpInput.clearInput();
      
      this.otp_generated_code = Math.floor(100000 + Math.random() * 900000);

      axios.post(`${process.env.VUE_APP_API_ENDPOINT}/signup/send-otp-code`, {
        phone: this.profile.phone,
        otp: btoa(this.otp_generated_code)
      });
    },
    verifyOtp(value) {
      let self = this;
      this.verifying_otp = true;

      setTimeout(function() {
        if (value == self.otp_generated_code) {
          self.save(true);
          self.$refs.otpInput.clearInput();

          self.verifying_otp = false;
          self.otp_valid = false;
          self.otp_attempted = false;
          self.show_phone_verification_modal = false;
          self.phone_number_changed = false;
        }
        else {
          self.otp_attempted = true;
          self.verifying_otp = false;
          self.otp_valid = false;
        }
      }, 1000);
    },
    handleOnChange(value) {

    },
    clearOtp() {
      this.otpInput = "";
    },
    async save(ignore_number_verification = false) {
      let self = this;

      if (!ignore_number_verification) {
        if (!this.me.parent_id) {
          if (this.phone_number_changed && this.profile.phone) {
            this.show_phone_verification_modal = true;
            setTimeout(function() {
              self.sendOtpSms();
            }, 300);
            return;
          }
        }
      }

      this.saving = true
      this.error = null

      // try {
        await this.$store.dispatch('me/save', {
          first_name: ((this.profile.first_name) ? this.profile.first_name.trim() : ""),
          last_name: ((this.profile.last_name) ? this.profile.last_name.trim() : ""),
          email: ((this.profile.email) ? this.profile.email.trim() : ""),
          phone: ((this.profile.phone) ? this.profile.phone.trim() : ""),
          address: ((this.profile.address) ? this.profile.address.trim() : ""),
          city: ((this.profile.city) ? this.profile.city.trim() : ""),
          state: ((this.profile.state) ? this.profile.state.trim() : ""),
          zip: ((this.profile.zip) ? this.profile.zip.trim() : ""),
          uuid: this.profile.uuid,
          company_name: ((this.profile.company_name) ? this.profile.company_name.trim() : ""),
          main_keyword: ((this.profile.main_keyword) ? this.profile.main_keyword.trim() : ""),

          lsa_profile_url: this.me.lsa_profile_url,
          ...(this.me.timezone ? { timezone: this.me.timezone } : {}),

          notifications_email_enabled: this.me.settings.notifications_email_enabled ? 1 : 0,
          notifications_emails: ((this.me.settings.notifications_emails) ? this.me.settings.notifications_emails : "_EMPTY_"),

          notifications_sms_enabled: this.me.settings.notifications_sms_enabled ? 1 : 0,
          notifications_phone_numbers: ((this.me.settings.notifications_phone_numbers) ? this.me.settings.notifications_phone_numbers : "_EMPTY_"),

          include_business_name_in_notifications: this.me.settings.include_business_name_in_notifications ? 1 : 0,

          notifications_license_expired: this.me.settings.notifications_license_expired ? 1 : 0,
          notifications_outside_goals_kpi_targets: this.me.settings.notifications_outside_goals_kpi_targets ? 1 : 0,
          notifications_missed_call: this.me.settings.notifications_missed_call ? 1 : 0,
          notifications_dropped_call: this.me.settings.notifications_dropped_call ? 1 : 0,
          notifications_incoming_ai_lead: this.me.settings.notifications_incoming_ai_lead ? 1 : 0,
          notifications_incoming_ai_reply: this.me.settings.notifications_incoming_ai_reply ? 1 : 0,
          notifications_incoming_ai_lead_ended_prematurely: this.me.settings.notifications_incoming_ai_lead_ended_prematurely ? 1 : 0,
          notifications_incoming_high_quality_lead: this.me.settings.notifications_incoming_high_quality_lead ? 1 : 0,
          notifications_incoming_web_conversation: this.me.settings.notifications_incoming_web_conversation ? 1 : 0,
          notifications_hasnt_replied_1_hour: this.me.settings.notifications_hasnt_replied_1_hour ? 1 : 0,
          notifications_replied_1_hour: this.me.settings.notifications_replied_1_hour ? 1 : 0,
          notifications_business_phone_number: this.me.settings.notifications_business_phone_number ? 1 : 0,
          notifications_daily_ai_report: this.me.settings.notifications_daily_ai_report ? 1 : 0,
          ai_report_daily_enabled: this.me.settings.ai_report_daily_enabled ? 1 : 0,
          ai_report_weekly_enabled: this.me.settings.ai_report_weekly_enabled ? 1 : 0,
          ai_report_monthly_enabled: this.me.settings.ai_report_monthly_enabled ? 1 : 0,
          notifications_monthly_lsa_report: this.me.settings.notifications_monthly_lsa_report ? 1 : 0,
          notifications_unresponded_message: this.me.settings.notifications_unresponded_message ? 1 : 0,
          notifications_weekly_report: this.me.settings.notifications_weekly_report ? 1 : 0,
          notifications_daily_report: this.me.settings.notifications_daily_report ? 1 : 0,
          notifications_monthly_report: this.me.settings.notifications_monthly_report ? 1 : 0,
          notifications_call_tagged: this.me.settings.notifications_call_tagged ? 1 : 0,
          notifications_dispute_resolved: this.me.settings.notifications_dispute_resolved ? 1 : 0,
          notifications_dispute_filed: this.me.settings.notifications_dispute_filed ? 1 : 0,
          notifications_incoming_call: this.me.settings.notifications_incoming_call ? 1 : 0,

          goal_answering_response_rate_enabled: this.me.settings.goal_answering_response_rate_enabled ? 1 : 0,
          goal_answering_response_rate: this.me.settings.goal_answering_response_rate,

          goal_reviews_responded_to_enabled: this.me.settings.goal_reviews_responded_to_enabled ? 1 : 0,
          goal_reviews_responded_to: this.me.settings.goal_reviews_responded_to,

          goal_answer_calls_enabled: this.me.settings.goal_answer_calls_enabled ? 1 : 0,
          goal_answer_calls: this.me.settings.goal_answer_calls,

          goal_reached_voicemail_enabled: this.me.settings.goal_reached_voicemail_enabled ? 1 : 0,
          goal_reached_voicemail: this.me.settings.goal_reached_voicemail,

          goal_reviews_per_week_enabled: this.me.settings.goal_reviews_per_week_enabled ? 1 : 0,
          goal_reviews_per_week: this.me.settings.goal_reviews_per_week,

          // Survey Settings
          auto_survey_enabled: this.me.settings.auto_survey_enabled ? 1 : 0,
          survey_prompt: this.me.integrations.bland.settings[0].survey_prompt,
          auto_survey_services: this.me.settings.auto_survey_services,
          auto_survey_non_services: this.me.settings.auto_survey_non_services,

          // Blacklist
          blacklisted_numbers: this.me.settings.blacklisted_numbers,


          customer_value: this.me.settings.customer_value
        })
        this.$store.dispatch('me/fetch')
      /*}catch(error){
        console.log(error)
        this.error = error
      }*/

      this.saving = false

      localStorage.setItem('business_user', JSON.stringify(this.profile));

      this.$swal({
        title: "Settings saved!",
        text: "Your settings have been successfully saved.",
        showCancelButton: false,
      });

    },

    async change_password() {

      this.changing = true
      this.error_password = null

      try {
        await this.$store.dispatch('me/change_password', {
          current_password: this.$refs.current_password.value,
          new_password: this.$refs.new_password.value,
          confirm_password: this.$refs.confirm_password.value,
          uuid: this.profile.uuid
        })
        
        this.password_changed = true

        this.$refs.current_password.value = '';
        this.$refs.new_password.value = '';
        this.$refs.confirm_password.value = '';
      } catch(error) {
        this.error_password = error
      }

      this.changing = false

      let self = this
      setTimeout(function() {
        self.password_changed = false
      }, 2000);
    },

    async removeLogo() {
      this.me.logo = '';
    },

    async saveCallRailSettings() {

      this.savingCallrail = true
      this.errorCallrail = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-callrail-settings`, {
        api_key: this.me.integrations.callrail.settings.api_key,
        selected_phone_numbers: this.me.integrations.callrail.settings.selected_phone_numbers,
        selected_phone_numbers_seo: this.me.integrations.callrail.settings.selected_phone_numbers_seo,
        selected_account_id: this.me.integrations.callrail.settings.selected_account_id
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {

        console.log('response.data', response.data)

        this.errorCallrail = false
        this.me.integrations.callrail.status = response.data.integration.status;
        this.me.integrations.callrail.settings.available_accounts = response.data.integration.settings.available_accounts;
        this.me.integrations.callrail.settings.available_phone_numbers = response.data.integration.settings.available_phone_numbers;
        this.me.integrations.callrail.settings.numbers_names = response.data.integration.settings.numbers_names;

        if (response.data.integration.status == 0)
          this.errorCallrail = "Your Callrail API key is invalid."
      }
      else {
        this.errorCallrail = response.data.error
      }

      this.errorCallrail = false
      this.savingCallrail = false

      let self = this

      if (this.me.integrations.callrail.settings.selected_phone_numbers.length > 0)
        self.callrail_saved = true;

      setTimeout(function() {
        self.callrail_saved = false;
      }, 5000);

      },

    async saveGhlSettings() {

      this.savingGhl = true
      this.errorGhl = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-ghl-settings`, {
        api_key: this.me.integrations.ghl.settings.api_key,
        api_key_v2: this.me.integrations.ghl.settings.api_key_v2,
        location_id: this.me.integrations.ghl.settings.location_id,
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {

        console.log('response.data', response.data)

        this.errorGhl = false
        this.me.integrations.ghl.status = response.data.integration.status;

        if (response.data.integration.status == 0) {
          this.errorGhl = "Your GHL API key is invalid."
        }
        else {
          let self = this

          self.ghl_saved = true;

          setTimeout(function() {
            self.ghl_saved = false;
          }, 5000);
        }
      }
      else {
        this.errorGhl = response.data.error
      }

      this.savingGhl = false
    },

    async saveCalendlySettings() {

      this.savingCalendly = true
      this.errorCalendly = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-calendly-settings`, {
        api_key: this.me.integrations.calendly.settings.api_key
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {

        console.log('response.data', response.data)

        this.errorCalendly = false
        this.me.integrations.calendly.status = response.data.integration.status;

        if (response.data.integration.status == 0) {
          this.errorCalendly = "Your Calendly API key is invalid."
        }
        else {
          let self = this

          self.calendly_saved = true;

          setTimeout(function() {
            self.calendly_saved = false;
          }, 5000);
        }
      }
      else {
        this.errorCalendly = response.data.error
      }

      this.savingCalendly = false
    },

    async saveDialpadSettings() {

      this.savingDialpad = true
      this.errorDialpad = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-dialpad-settings`, {
        api_key: this.me.integrations.dialpad.settings.api_key
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {

        console.log('response.data', response.data)

        this.errorDialpad = false
        this.me.integrations.dialpad.status = response.data.integration.status;

        if (response.data.integration.status == 0) {
          this.errorDalendly = "Your Calendly API key is invalid."
        }
        else {
          let self = this

          self.dialpad_saved = true;

          setTimeout(function() {
            self.dialpad_saved = false;
          }, 5000);
        }
      }
      else {
        this.errorDialpad = response.data.error
      }

      this.savingDialpad = false
    },

    async saveCrmSettings() {

      this.savingCrm = true
      this.errorCrm = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-crm-settings`, {
        type: this.me.integrations.crm.settings.type,
        email: this.me.integrations.crm.settings.email,
        password: this.me.integrations.crm.settings.password,
        send_leads: this.me.integrations.crm.settings.send_leads,
        create_booking: this.me.integrations.crm.settings.create_booking,
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {

        console.log('response.data', response.data)

        this.errorCrm = false
        this.me.integrations.crm.status = response.data.integration.status;

        if (response.data.integration.status == 0) {
          this.errorCrm = "Your credentials are invalid."
        }
        else {
          let self = this

          self.crm_saved = true;

          setTimeout(function() {
            self.crm_saved = false;
          }, 5000);
        }
      }
      else {
        this.errorCrm = response.data.error
      }

      this.savingCrm = false
    },

    AuthProvider(provider, calendar = 0, gmail = 0) {

      let self = this;

      // console.log('gmail url', process.env.VUE_APP_API_ENDPOINT + '/auth/'+provider + "?jwt=" + this.me.uuid + "&host=" + window.location.origin + "&calendar=" + calendar + "&gmail=" + gmail)

      this.window_open = this.popupCenter('https://lsaapi.revulsab.com/auth/'+provider + "?jwt=" + this.me.uuid + "&host=" + window.location.origin + "&calendar=" + calendar + "&gmail=" + gmail, 'window_open', 800, 900);

      if (this.window_proc) {
        clearInterval(this.window_proc);
        this.window_proc = null;
      }

      this.window_proc = setInterval(function() {
        try {
          // console.log(self.window_open.location.pathname);
          if (self.window_open.location.pathname == "/social-login-done") {
            self.window_open.close();
            self.window_open = null;
            clearInterval(self.window_proc);
            self.window_proc = null;

            self.$store.dispatch('me/fetch')
            self.refreshLsaAccountsList();
          }
        }
        catch (e) {
          console.log(e);
        }
      }, 300);

      return;

    },

    popupCenter(url, title, w, h) {
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
    },

    connectGoogleAdsAccount() {
      this.AuthProvider('google');
    },

    async saveGoogleAdsSettings() {

      this.savingGoogleAds = true
      this.errorGoogleAds = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-google-ads-settings`, {
        selected_manager_id: this.me.integrations.google_ads.settings.selected_manager_id,
        selected_client_id: this.me.integrations.google_ads.settings.selected_client_id
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingGoogleAds = false
      }
      else {
        this.errorGoogleAds = response.data.error
      }

      this.savingGoogleAds = false

      },

    async getLicenses() {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/get-lsa-licenses`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.licenses = response.data.licenses;

    },

    async getCallFlow() {
      let response = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/call-flows/get-call-flow`, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (!response.data.call_flow.settings.business_hours_list)
        response.data.call_flow.settings.business_hours_list = this.business_hours_list;
      else {
        if (response.data.call_flow.settings.business_hours_list.length == 0)
          response.data.call_flow.settings.business_hours_list = this.business_hours_list;
      }

      if (typeof response.data.call_flow.settings.weekend_number === 'undefined' || response.data.call_flow.settings.weekend_number === null) {
        this.$set(response.data.call_flow.settings, 'weekend_number', '');
      }

      this.call_flow = response.data.call_flow;

    },

    async saveCallFlow() {

      this.savingCallFlow = true

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-flows/save-call-flow`, {
        settings: this.call_flow.settings
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.savingCallFlow = false

      this.$swal({
        title: "Settings saved!",
        text: "Your Call Flow settings have been successfully saved.",
        showCancelButton: false,
      });

    },

    async doCreated() {
      let self = this;

      await this.$store.dispatch('me/fetch');

      this.webhook_payload = '{"From": "+11111111111", "To": "+12222222222", "MessageType": "generated", "Body": "", "ApiToken": "' + this.me.uuid + '"}';

      this.fetchWebhook();

      this.getLicenses();

      this.getCallFlow();

      this.fetchCosts();

      if (window.location.href.indexOf('ghl_connected') != -1)
        self.show_ghl_popup = true;
      
      if (self.me.integrations.bland.status == 1) {
        setTimeout(function() {
          self.blandNumberSelected = self.me.integrations.bland.settings[0];

          self.setTransferList();
          self.getBotDetails();
          self.getShareableLink();
        }, 1000);
      }

      if (window.location.href.indexOf('setup_ai') != -1) {
        setTimeout(function() {
          self.show_bland_popup = true;
        }, 1000);
      }

      self.refreshLsaAccountsList();
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile
    })
  },
  created() {
    this.doCreated();
  }
}
</script>

<style>

.v-dialog {
  height: 596px !important;
}

</style>

<style scoped>

.setting-header {
  background-color: #fbfbfb;
}
.setting-body {
  background-color: #fdfdfd;
}

input, textarea {
  border-style: solid;
}

.v-icon.v-icon {
  font-size: 14px !important;
}

.remove-applet-btn {
  background: gray;
  border: solid 1px #FFFFFF;
  border-radius: 50%;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  line-height: 16px;
  text-align: center;
  right: -8px;
  top: -8px;
  z-index: 10;
}

.v-timeline-item {
  padding-bottom: 35px;
}

.v-timeline-item .v-alert {
  cursor: pointer;
}

.v-timeline-item .remove-applet-btn {
  display: none;
}

.v-timeline-item:hover .remove-applet-btn {
  display: block;
}

.add-applet-btn {
  position:absolute;
  bottom: 30 px;
}

.v-timeline .v-timeline-item:nth-child(odd) .add-applet-btn {
  left: -72px;
}

.v-timeline .v-timeline-item:nth-child(even) .add-applet-btn {
  right: -72px;
}
.token_password_toggle {
  position: absolute;
  margin-top: -36px;
  right: 35px;
}
.gravatar-pic {
  border-radius: 50%;
  width: 100px;
  display: initial;
  margin-bottom: 6px;
}

.rg-pic-wrapper .rg-pic-uploader-wrapper {
  display: none;
}

.rg-pic-wrapper:hover .rg-pic-uploader-wrapper {
  display: block;
}

@media screen and (max-width: 500px) {
  .flxmtten {
    margin-top: -15px !important;
  }
}
</style>